import React from 'react';
import { useUniqueId } from '../../../utils/unique-id.esm.js';

/** partial svg element for each icon here are design to take advantage of the of 'currentcolor' inheritance from the wrapping html element  */
var svgIcons = {
  check: {
    size: 18,
    viewBox: '0 0 18 18',
    message: "[<Icon icon=\"check\" /> is a deprecated] --- use import { IconCheck } from '@costar/theme-ui-icons/csg/IconCheck'",
    element: function element(props) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn("[<Icon icon=\"filter\" /> is a deprecated] --- use import { IconCheck } from '@costar/theme-ui-icons/csg/IconCheck'");
      }
      return /*#__PURE__*/React.createElement("g", {
        stroke: "currentcolor",
        fill: "none",
        strokeWidth: props.strokeWidth ? props.strokeWidth : 2,
        filter: props.filter
      }, /*#__PURE__*/React.createElement("polyline", {
        points: "4 8.4416119 7.37887314 11.9346654 14.3487723 5.04017857"
      }));
    }
  },
  filter: {
    size: 15,
    viewBox: '0 0 15 15',
    message: "[<Icon icon=\"filter\" /> is a deprecated] --- use import { IconFilter } from '@costar/theme-ui-icons/csg/IconFilter'",
    element: function element(props) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn("[<Icon icon=\"filter\" /> is a deprecated] --- use import { IconFilter } from '@costar/theme-ui-icons/csg/IconFilter'");
      }
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        fillRule: "nonzero",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "m4.5 10.5c.932 0 1.714.637 1.937 1.499l7.563.001 0 1-7.563 0c-.222.863-1.005 1.5-1.937 1.5-.932 0-1.715-.637-1.937-1.5l-2.563 0 0-1 2.563-.001c.222-.862 1.005-1.499 1.937-1.499zm0 1c-.552 0-1 .448-1 1 0 .552.448 1 1 1 .552 0 1-.448 1-1 0-.552-.448-1-1-1zm5-6c.932 0 1.714.637 1.937 1.499l2.563.001 0 1-2.563 0c-.222.863-1.005 1.5-1.937 1.5-.932 0-1.715-.637-1.937-1.5l-7.563 0 0-1 7.563-.001c.222-.862 1.005-1.499 1.937-1.499zm0 1c-.552 0-1 .448-1 1 0 .552.448 1 1 1 .552 0 1-.448 1-1 0-.552-.448-1-1-1zm-6-6c.932 0 1.714.637 1.937 1.499l8.563.001 0 1-8.563 0c-.222.863-1.005 1.5-1.937 1.5-.932 0-1.715-.637-1.937-1.5l-1.563 0 0-1 1.563-.001c.222-.862 1.005-1.499 1.937-1.499zm0 1c-.552 0-1 .448-1 1 0 .552.448 1 1 1 .552 0 1-.448 1-1 0-.552-.448-1-1-1z"
      }));
    }
  },
  close: {
    size: 16,
    viewBox: '0 0 16 16',
    message: "[<Icon icon=\"close\" /> is a deprecated] --- use import { IconClose } from '@costar/theme-ui-icons/md/IconClose'",
    element: function element(props) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn("[<Icon icon=\"close\" /> is a deprecated] --- use import { IconClose } from '@costar/theme-ui-icons/md/IconClose'");
      }
      return /*#__PURE__*/React.createElement("g", {
        stroke: "currentcolor",
        strokeWidth: props.strokeWidth ? props.strokeWidth : 1.5,
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "m1 1 14 14m0-14-14 14"
      }));
    }
  },
  corporateFare: {
    size: 24,
    viewBox: '0 0 24 24',
    message: "[<Icon icon=\"corporateFare\" /> is a deprecated] --- use import { IconCorporateFare } from '@costar/theme-ui-icons/csg/IconCorporateFare'",
    element: function element(props) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn("[<Icon icon=\"corporateFare\" /> is a deprecated] --- use import { IconCorporateFare } from '@costar/theme-ui-icons/csg/IconCorporateFare'");
      }
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M12 7V3H2v18h20V7zm-2 12H4v-2h6zm0-4H4v-2h6zm0-4H4V9h6zm0-4H4V5h6zm10 12h-8V9h8zm-2-8h-4v2h4zm0 4h-4v2h4z"
      }));
    }
  },
  search: {
    size: 22,
    viewBox: '0 0 22 22',
    message: "[<Icon icon=\"search\" /> is a deprecated] --- use import { IconSearch } from '@costar/theme-ui-icons/csg/IconSearch'",
    element: function element(props) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn("[<Icon icon=\"search\" /> is a deprecated] --- use import { IconSearch } from '@costar/theme-ui-icons/csg/IconSearch'");
      }
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        fill: "currentcolor",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(-42, -41)"
      }, /*#__PURE__*/React.createElement("path", {
        d: "m51 41c5 0 9 4 9 9 0 2-1 4-2 6l0 0 6 6-1 1-6-6c-2 1-3 2-6 2-5 0-9-4-9-9 0-5 4-9 9-9zm0 1c-5 0-8 4-8 8 0 5 4 8 8 8 5 0 8-4 8-8 0-5-4-8-8-8z"
      })));
    }
  },
  info: {
    size: 15,
    viewBox: '0 0 15 15',
    message: "[<Icon icon=\"info\" /> is a deprecated] --- use import { IconInfoBorder } from '@costar/theme-ui-icons/csg/IconInfoBorder'",
    element: function element(props) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn("[<Icon icon=\"info\" /> is a deprecated] --- use import { IconInfoBorder } from '@costar/theme-ui-icons/csg/IconInfoBorder'");
      }
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: props.strokeWidth || 1,
        fill: "currentcolor",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "m6.533 9.8 0-3.733-.35 0c-.064 0-.117-.052-.117-.117l0-.467c0-.064.052-.117.117-.117l1.517 0 0 4.433.35 0c.064 0 .117.052 .117.117l0 .467c0 .064-.052.117-.117.117l-2.1 0c-.064 0-.117-.052-.117-.117l0-.467c0-.064.052-.117.117-.117l.583 0zm.467-4.9c-.387 0-.7-.313-.7-.7 0-.387.313-.7.7-.7.387 0 .7.313 .7.7 0 .387-.313.7-.7.7zm0 8.4c3.479 0 6.3-2.821 6.3-6.3 0-3.479-2.821-6.3-6.3-6.3-3.479 0-6.3 2.821-6.3 6.3 0 3.479 2.821 6.3 6.3 6.3zm0 .7c-3.866 0-7-3.134-7-7 0-3.866 3.134-7 7-7 3.866 0 7 3.134 7 7 0 3.866-3.134 7-7 7z"
      }));
    }
  },
  analytic: {
    size: 18,
    viewBox: '0 0 18 18',
    message: "[<Icon icon=\"analytic\" /> is a deprecated] --- use import { IconChartBars1 } from '@costar/theme-ui-icons/csg/IconChartBars1'",
    element: function element(props) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn("[<Icon icon=\"analytic\" /> is a deprecated] --- use import { IconChartBars1 } from '@costar/theme-ui-icons/csg/IconChartBars1'");
      }
      return /*#__PURE__*/React.createElement("g", {
        stroke: "currentcolor",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("rect", {
        transform: "translate(15.630711, 8.333333) scale(-1, 1) translate(-15.630711, -8.333333) ",
        x: "14.2614226",
        y: "0.833333333",
        width: "2.73857742",
        height: "15",
        rx: "1"
      }), /*#__PURE__*/React.createElement("rect", {
        transform: "translate(11.130711, 10.000000) scale(-1, 1) translate(-11.130711, -10.000000) ",
        x: "9.76142258",
        y: "4.16666667",
        width: "2.73857742",
        height: "11.6666667",
        rx: "1"
      }), /*#__PURE__*/React.createElement("rect", {
        transform: "translate(6.630711, 11.666667) scale(-1, 1) translate(-6.630711, -11.666667) ",
        x: "5.26142258",
        y: "7.5",
        width: "2.73857742",
        height: "8.33333333",
        rx: "1"
      }), /*#__PURE__*/React.createElement("rect", {
        transform: "translate(2.130711, 13.333333) scale(-1, 1) translate(-2.130711, -13.333333) ",
        x: "0.761422579",
        y: "10.8333333",
        width: "2.73857742",
        height: "5",
        rx: "1"
      }));
    }
  },
  map: {
    size: 21,
    viewBox: '0 0 21 17',
    message: "[<Icon icon=\"map\" /> is a deprecated] --- use import { IconMap } from '@costar/theme-ui-icons/csg/IconMap'",
    element: function element(props) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn("[<Icon icon=\"map\" /> is a deprecated] --- use import { IconMap } from '@costar/theme-ui-icons/csg/IconMap'");
      }
      return /*#__PURE__*/React.createElement("g", {
        stroke: "currentcolor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.25",
        fill: "none",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("polygon", {
        points: "6.33333333 0.733710047 6.33333333 13.6124979 0 15.9090909 0 3.03030303"
      }), /*#__PURE__*/React.createElement("polygon", {
        points: "19 0.757575758 19 13.6363636 12.6666667 15.9329566 12.6666667 3.05416874"
      }), /*#__PURE__*/React.createElement("polygon", {
        transform: "translate(9.500000, 8.345266) scale(-1, 1) translate(-9.500000, -8.345266) ",
        points: "12.6666667 0.757575758 12.6666667 13.6363636 6.33333333 15.9329566 6.33333333 3.05416874"
      }));
    }
  },
  list: {
    size: 21,
    viewBox: '0 0 21 17',
    message: "[<Icon icon=\"list\" /> is a deprecated] --- use import { IconList } from '@costar/theme-ui-icons/csg/IconList'",
    element: function element(props) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn("[<Icon icon=\"list\" /> is a deprecated] --- use import { IconList } from '@costar/theme-ui-icons/csg/IconList'");
      }
      return /*#__PURE__*/React.createElement("g", {
        stroke: "currentcolor",
        strokeLinecap: "square",
        strokeWidth: "1.25",
        fill: "none",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M4.5,1.5 L19.5,1.5"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M0.0625,1.5 L1.9375,1.5"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M4.5,5.5 L19.5,5.5"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M0.0625,5.5 L1.9375,5.5"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M4.5,9.5 L19.5,9.5"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M0.0625,9.5 L1.9375,9.5"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M4.5,13.5 L19.5,13.5"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M0.0625,13.5 L1.9375,13.5"
      }));
    }
  },
  favorite: {
    size: 28,
    viewBox: '0 0 28 28',
    message: "[<Icon icon=\"favorite\" /> is a deprecated] --- use import { IconHeart } from '@costar/theme-ui-icons/csg/IconHeart'",
    element: function element(props) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn("[<Icon icon=\"favorite\" /> is a deprecated] --- use import { IconHeart } from '@costar/theme-ui-icons/csg/IconHeart'");
      }
      return /*#__PURE__*/React.createElement("g", {
        stroke: "currentcolor",
        strokeWidth: props.strokeWidth ? props.strokeWidth : 2,
        fill: "none",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "m15.03 26.819c-1.507-1.174-4.615-3.723-7.504-6.876-4.138-4.516-6.326-8.646-6.326-11.943 0-3.805 3.09-6.9 6.888-6.9 2.5 0 4.807 1.364 6.023 3.561l.919 1.66.919-1.66c1.216-2.197 3.524-3.561 6.023-3.561 3.798 0 6.888 3.095 6.888 6.9 0 3.297-2.187 7.427-6.326 11.943-3.807 3.885-5.998 5.702-7.505 6.876z"
      }));
    }
  },
  expand: {
    size: 15,
    viewBox: '0 0 15 15',
    message: "[<Icon icon=\"expand\" /> is a deprecated] --- use import { IconExpand } from '@costar/theme-ui-icons/csg/IconExpand'",
    element: function element(props) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn("[<Icon icon=\"expand\" /> is a deprecated] --- use import { IconExpand } from '@costar/theme-ui-icons/csg/IconExpand'");
      }
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        stroke: "currentcolor",
        strokeWidth: props.strokeWidth ? props.strokeWidth : 0.5,
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("polygon", {
        points: "13.2 1.2 9.4 1.2 9.3 1.1 9.3 0.5 9.4 0.4 14.4 0.4 14.5 0.5 14.5 5.5 14.4 5.6 13.8 5.6 13.7 5.5 13.7 1.7 7.7 7.7 7.5 7.7 7.1 7.3 7.1 7.1"
      }), /*#__PURE__*/React.createElement("polygon", {
        points: "1.2 1.2 1.2 13.8 13.8 13.8 13.8 8.9 13.9 8.8 14.5 8.8 14.6 8.9 14.6 14.5 14.5 14.6 0.5 14.6 0.4 14.5 0.4 0.5 0.5 0.4 6.1 0.4 6.2 0.5 6.2 1.1 6.1 1.2 1.2 1.2"
      }));
    }
  },
  circle: {
    size: 26,
    viewBox: '0 0 26 26',
    element: function element(props) {
      var _props$secondaryColor, _props$strokeWidth;
      return /*#__PURE__*/React.createElement("g", {
        stroke: (_props$secondaryColor = props.secondaryColor) !== null && _props$secondaryColor !== void 0 ? _props$secondaryColor : 'currentcolor',
        strokeWidth: (_props$strokeWidth = props.strokeWidth) !== null && _props$strokeWidth !== void 0 ? _props$strokeWidth : 2,
        fill: typeof props.fill === 'number' ? 'currentcolor' : typeof props.fill === 'string' ? props.fill : 'none',
        fillOpacity: typeof props.fill === 'number' ? props.fill : undefined,
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M13,25 C19.627417,25 25,19.627417 25,13 C25,6.372583 19.627417,1 13,1 C6.372583,1 1,6.372583 1,13 C1,19.627417 6.372583,25 13,25 Z"
      }));
    }
  },
  remove: {
    size: 26,
    viewBox: '0 0 26 26',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: props.strokeWidth ? props.strokeWidth : 1,
        fill: "none",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M13,25 C19.627417,25 25,19.627417 25,13 C25,6.372583 19.627417,1 13,1 C6.372583,1 1,6.372583 1,13 C1,19.627417 6.372583,25 13,25 Z",
        stroke: "currentcolor",
        strokeWidth: "2"
      }), /*#__PURE__*/React.createElement("rect", {
        fill: "currentcolor",
        x: "6",
        y: "12",
        width: "14",
        height: "2"
      }));
    }
  },
  add: {
    size: 26,
    viewBox: '0 0 26 26',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: props.strokeWidth ? props.strokeWidth : 1,
        fill: "none",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M13,25 C19.627417,25 25,19.627417 25,13 C25,6.372583 19.627417,1 13,1 C6.372583,1 1,6.372583 1,13 C1,19.627417 6.372583,25 13,25 Z",
        stroke: "currentcolor",
        strokeWidth: "2"
      }), /*#__PURE__*/React.createElement("rect", {
        fill: "currentcolor",
        x: "6",
        y: "12",
        width: "14",
        height: "2"
      }), /*#__PURE__*/React.createElement("rect", {
        fill: "currentcolor",
        x: "12",
        y: "6",
        width: "2",
        height: "14"
      }));
    }
  },
  select: {
    size: 26,
    viewBox: '0 0 26 26',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        stroke: "currentcolor",
        strokeWidth: props.strokeWidth ? props.strokeWidth : 2,
        fill: "none",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M13,25 C19.627417,25 25,19.627417 25,13 C25,6.372583 19.627417,1 13,1 C6.372583,1 1,6.372583 1,13 C1,19.627417 6.372583,25 13,25 Z"
      }), /*#__PURE__*/React.createElement("polyline", {
        points: "19 9 10.6939045 17 7 13.4422229"
      }));
    }
  },
  selected: {
    size: 26,
    viewBox: '0 0 18 18',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        stroke: "currentcolor",
        strokeWidth: props.strokeWidth ? props.strokeWidth : 1.5,
        fill: "currentcolor",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M9 17A8 8 0 109 1a8 8 0 000 16z"
      }), /*#__PURE__*/React.createElement("path", {
        stroke: props.secondaryColor ? props.secondaryColor : '#FFF',
        d: "M13.065 6.277L7.351 11.93 4.81 9.416"
      }));
    }
  },
  arrowUp: {
    size: 11,
    viewBox: '0 0 9 11',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: props.strokeWidth ? props.strokeWidth : 1,
        fill: "currentcolor",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(-1, -1)"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M5,10.2928932 L5,1.5 C5,1.22385763 5.22385763,1 5.5,1 C5.77614237,1 6,1.22385763 6,1.5 L6,10.2805085 L8.82062104,7.3596699 C9.01244565,7.1610297 9.32897992,7.15550457 9.52762012,7.34732919 C9.72626032,7.5391538 9.73178545,7.85568807 9.53996084,8.05432827 L6.06666899,11.6510273 C6.02685223,11.6922587 5.84350909,11.870985 5.78142889,11.9133355 C5.70126242,11.9680244 5.60436536,12 5.5,12 C5.39180396,12 5.29163452,11.965634 5.20981178,11.9072222 C5.13679431,11.8550963 4.93449044,11.6415972 4.8890873,11.5961941 L1.35355339,8.06066017 C1.15829124,7.86539803 1.15829124,7.54881554 1.35355339,7.35355339 C1.54881554,7.15829124 1.86539803,7.15829124 2.06066017,7.35355339 L5,10.2928932 Z",
        transform: "translate(5.443699, 6.500000) scale(1, -1) translate(-5.443699, -6.500000)"
      })));
    }
  },
  arrowDown: {
    size: 11,
    viewBox: '0 0 9 11',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: props.strokeWidth ? props.strokeWidth : 1,
        fill: "currentcolor",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(-1, -1)"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M5,10.2928932 L5,1.5 C5,1.22385763 5.22385763,1 5.5,1 C5.77614237,1 6,1.22385763 6,1.5 L6,10.2805085 L8.82062104,7.3596699 C9.01244565,7.1610297 9.32897992,7.15550457 9.52762012,7.34732919 C9.72626032,7.5391538 9.73178545,7.85568807 9.53996084,8.05432827 L6.06666899,11.6510273 C6.02685223,11.6922587 5.84350909,11.870985 5.78142889,11.9133355 C5.70126242,11.9680244 5.60436536,12 5.5,12 C5.39180396,12 5.29163452,11.965634 5.20981178,11.9072222 C5.13679431,11.8550963 4.93449044,11.6415972 4.8890873,11.5961941 L1.35355339,8.06066017 C1.15829124,7.86539803 1.15829124,7.54881554 1.35355339,7.35355339 C1.54881554,7.15829124 1.86539803,7.15829124 2.06066017,7.35355339 L5,10.2928932 Z"
      })));
    }
  },
  chevronLeft: {
    size: 18,
    viewBox: '0 0 10 18',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        stroke: "currentcolor",
        strokeWidth: props.strokeWidth ? props.strokeWidth : 1.5,
        fill: "none",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(0, 1)"
      }, /*#__PURE__*/React.createElement("polyline", {
        points: "8 0 0 7.59860237 8 16"
      })));
    }
  },
  chevronRight: {
    size: 18,
    viewBox: '0 0 10 18',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        stroke: "currentcolor",
        strokeWidth: props.strokeWidth ? props.strokeWidth : 1.5,
        fill: "none",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(0, 1)"
      }, /*#__PURE__*/React.createElement("polyline", {
        points: "8 0 0 7.59860237 8 16",
        transform: "translate(5.000000, 8.000000) scale(-1, 1) translate(-5.000000, -8.000000)"
      })));
    }
  },
  chevronDown: {
    size: 18,
    viewBox: '0 0 22 14',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        fillRule: "nonzero",
        strokeWidth: "1",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("polygon", {
        transform: "translate(10.943573, 6.784723) rotate(-90.000000) translate(-10.943573, -6.784723)",
        points: "8.99822203 6.3959974 17.3272541 15.1429362 15.0551743 17.3064618 4.55989158 6.28458137 15.1108823 -3.73701648 17.2715461 -1.46221511"
      }));
    }
  },
  chevronUp: {
    size: 18,
    viewBox: '0 0 22 14',
    element: function element(props) {
      var _props$strokeWidth2 = props.strokeWidth,
        strokeWidth = _props$strokeWidth2 === void 0 ? 1.5 : _props$strokeWidth2,
        filter = props.filter;
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        fillRule: "nonzero",
        strokeWidth: strokeWidth,
        filter: filter
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(4.25, -4.8)"
      }, /*#__PURE__*/React.createElement("polygon", {
        transform: "translate(6.772468, 11.163296) scale(-1, 1) rotate(90) translate(-6.772468, -11.163296)",
        points: "4.82711718 10.7745706 13.1561493 19.5215094 10.8840694 21.685035 0.388786728 10.6631546 10.9397774 0.641556744 13.1004413 2.91635811"
      })));
    }
  },
  chevronUpDouble: {
    size: 22,
    viewBox: '0 0 26 22',
    element: function element(props) {
      var _props$strokeWidth3 = props.strokeWidth,
        strokeWidth = _props$strokeWidth3 === void 0 ? 2 : _props$strokeWidth3,
        filter = props.filter;
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        fillRule: "nonzero",
        strokeWidth: strokeWidth,
        filter: filter,
        transform: "translate(24, -2) rotate(90)"
      }, /*#__PURE__*/React.createElement("polygon", {
        points: "4.73299636 10.588079 12.9695849 19.237936 10.7227228 21.3774487 0.343926721 10.4778996 10.7778125 0.567530966 12.9144952 2.81708442"
      }), /*#__PURE__*/React.createElement("polygon", {
        points: "25.3798413 19.237936 23.1329792 21.3774487 12.7541831 10.4778996 23.1880689 0.567530966 25.3247516 2.81708442 17.1432528 10.588079"
      }));
    }
  },
  chevronDownDouble: {
    size: 22,
    viewBox: '0 0 26 22',
    element: function element(props) {
      var _props$strokeWidth4 = props.strokeWidth,
        strokeWidth = _props$strokeWidth4 === void 0 ? 2 : _props$strokeWidth4,
        filter = props.filter;
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        fillRule: "nonzero",
        strokeWidth: strokeWidth,
        filter: filter,
        transform: "rotate(-90) translate(-24, 2)"
      }, /*#__PURE__*/React.createElement("polygon", {
        points: "4.73299636 10.588079 12.9695849 19.237936 10.7227228 21.3774487 0.343926721 10.4778996 10.7778125 0.567530966 12.9144952 2.81708442"
      }), /*#__PURE__*/React.createElement("polygon", {
        points: "25.3798413 19.237936 23.1329792 21.3774487 12.7541831 10.4778996 23.1880689 0.567530966 25.3247516 2.81708442 17.1432528 10.588079"
      }));
    }
  },
  chevronLeftDouble: {
    size: 22,
    viewBox: '0 0 26 22',
    element: function element(props) {
      var _props$strokeWidth5 = props.strokeWidth,
        strokeWidth = _props$strokeWidth5 === void 0 ? 2 : _props$strokeWidth5,
        filter = props.filter;
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        fillRule: "nonzero",
        strokeWidth: strokeWidth,
        filter: filter
      }, /*#__PURE__*/React.createElement("polygon", {
        points: "4.73299636 10.588079 12.9695849 19.237936 10.7227228 21.3774487 0.343926721 10.4778996 10.7778125 0.567530966 12.9144952 2.81708442"
      }), /*#__PURE__*/React.createElement("polygon", {
        points: "25.3798413 19.237936 23.1329792 21.3774487 12.7541831 10.4778996 23.1880689 0.567530966 25.3247516 2.81708442 17.1432528 10.588079"
      }));
    }
  },
  chevronRightDouble: {
    size: 22,
    viewBox: '0 0 26 22',
    element: function element(props) {
      var _props$strokeWidth6 = props.strokeWidth,
        strokeWidth = _props$strokeWidth6 === void 0 ? 2 : _props$strokeWidth6,
        filter = props.filter;
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        strokeWidth: strokeWidth,
        filter: filter,
        transform: "rotate(180) translate(-28, -22)"
      }, /*#__PURE__*/React.createElement("polygon", {
        points: "4.73299636 10.588079 12.9695849 19.237936 10.7227228 21.3774487 0.343926721 10.4778996 10.7778125 0.567530966 12.9144952 2.81708442"
      }), /*#__PURE__*/React.createElement("polygon", {
        points: "25.3798413 19.237936 23.1329792 21.3774487 12.7541831 10.4778996 23.1880689 0.567530966 25.3247516 2.81708442 17.1432528 10.588079"
      }));
    }
  },
  star: {
    size: 18,
    viewBox: '-3 -4 34 34',
    element: function element(props) {
      var id = props.id,
        fill = props.fill,
        strokeWidth = props.strokeWidth,
        filter = props.filter,
        secondaryColor = props.secondaryColor,
        disabled = props.disabled;
      // eslint-disable-next-line react-hooks/rules-of-hooks
      var identifier = id || useUniqueId('svg-star');
      return /*#__PURE__*/React.createElement(React.Fragment, null, typeof fill === 'number' && /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
        id: identifier,
        x1: "0",
        y1: "0",
        x2: "1",
        y2: "0"
      }, /*#__PURE__*/React.createElement("stop", {
        id: "stop1",
        offset: fill,
        stopColor: "currentcolor"
      }), /*#__PURE__*/React.createElement("stop", {
        id: "stop2",
        offset: fill,
        stopColor: secondaryColor
      }))), /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: strokeWidth ? strokeWidth : 1.5,
        fill: typeof fill === 'number' ? "url(#".concat(identifier, ")") : typeof fill === 'string' ? fill : '#ffffff',
        fillRule: "evenodd",
        filter: filter
      }, /*#__PURE__*/React.createElement("polygon", {
        points: "17.0509596 0 21.9436293 11.1598595 34.1019192 12.3501975 24.9674281 20.4376799 27.5891392 32.3332073 17.0509596 26.1717082 6.51277999 32.3332073 9.13449111 20.4376799 -3.55271368e-15 12.3501975 12.1582899 11.1598595",
        transform: "scale(0.8)",
        stroke: fill ? 'currentcolor' : disabled ? '#bfbfbf' : '#757575',
        strokeWidth: strokeWidth ? strokeWidth : 4
      })));
    }
  },
  pin: {
    size: {
      width: 20,
      height: 33
    },
    viewBox: '0 0 20 33',
    element: function element(props) {
      var secondaryColor = props.secondaryColor,
        _props$strokeWidth7 = props.strokeWidth,
        strokeWidth = _props$strokeWidth7 === void 0 ? '1' : _props$strokeWidth7;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
        cx: "50%",
        cy: "49.6469329%",
        fx: "50%",
        fy: "49.6469329%",
        r: "165.201786%",
        gradientTransform: "translate(0.500000,0.496469),scale(0.304348,1.000000),scale(1.000000,0.274581),translate(-0.500000,-0.496469)",
        id: "radialGradient-1"
      }, /*#__PURE__*/React.createElement("stop", {
        stopColor: "#001122",
        stopOpacity: "0.537760417",
        offset: "0%"
      }), /*#__PURE__*/React.createElement("stop", {
        stopColor: "#001122",
        stopOpacity: "0",
        offset: "100%"
      }))), /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: strokeWidth,
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("g", {
        id: "Group-98"
      }, /*#__PURE__*/React.createElement("ellipse", {
        id: "Oval",
        fill: "url(#radialGradient-1)",
        cx: "10",
        cy: "30.4",
        rx: "9.2",
        ry: "2.8"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M0.8,11 C0.6,10.6 0.7,10 1,9.6 L9.4,1.2 C9.7,0.9 10.2,0.9 10.5,1.2 L19,9.6 C19.3,9.9 19.4,10.5 19.2,11 L10.5,29.6 C10.3,30 10,30 9.8,29.6 L0.8,11 Z",
        id: "Shape",
        stroke: secondaryColor,
        fill: "currentcolor"
      }))));
    }
  },
  costarLogo: {
    size: {
      width: 266,
      height: 72
    },
    viewBox: '0 0 266 72',
    element: function element() {
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("path", {
        d: "m10.271 15.861 24.176 6.698c.485.132 1.105-.08 1.392-.481l8.837-12.182c.285-.414.184-.981-.229-1.269l-12.517-8.431c-.408-.273-1.067-.259-1.471.031l-20.326 14.831c-.402.299-.339.661 .138.803zm39.424-11.09 1.129 25.17c.016.499 .416 1.026.885 1.18l14.259 4.679c.483.144 .987-.132 1.132-.61l4.111-14.568c.135-.471-.083-1.101-.485-1.395l-20.317-14.843c-.407-.289-.73-.118-.715.387zm22.679 34.235-23.475 8.856c-.469.173-.841.714-.841 1.21l-.024 15.072c.013.503 .425.904 .928.892l15.053-.572c.495-.017 1.016-.419 1.172-.893l7.772-24c.149-.48-.118-.738-.584-.565zm-25.401 32.259-15.636-19.699c-.307-.393-.939-.586-1.407-.434l-14.271 4.635c-.473.167-.724.684-.558 1.164l5.189 14.213c.171.463 .714.839 1.212.839l25.118.017c.501-.007.661-.338.353-.735zm-39.171-14.417-7.75-24.012c-.153-.475.037-1.108.425-1.414l11.844-9.357c.4-.304.97-.224 1.273.178l8.798 12.202c.292.401 .301 1.062.027 1.479l-13.811 21.033c-.287.412-.645.364-.806-.109z",
        fill: "#0054A6"
      }), /*#__PURE__*/React.createElement("path", {
        d: "m259.892 38.15h.824v-3.706c0-.147-.004-.379-.012-.694-.01-.315-.014-.55-.014-.703v-.192l1.835 5.295h.853l1.817-5.295c0 .339-.002.658-.008.954-.006.296-.01.507-.01.635v3.706h.823v-6.277h-1.226l-1.817 5.307-1.829-5.307h-1.236v6.277zm-5.928-6.277v.748h2.143v5.53h.871v-5.53h2.145v-.748h-5.159zm-33.974 12.732-8.424 2.608c-1.687.522-2.646 1.476-2.646 3.282 0 2.706 1.729 4.083 4.383 4.083 2.834 0 4.426-1.233 6.687-2.943v-7.029zm8.623 9.906c.169.5 .481 1.27.604 1.622-1.512 1.313-2.936 1.867-4.555 1.867-2.504 0-3.754-1.711-4.529-4.324-1.778 1.948-4.522 4.324-9.002 4.324-4.762 0-7.316-2.803-7.316-6.509 0-4.42 3.179-5.466 6.886-6.504l9.289-2.714v-.996c0-3.896-1.828-6.935-5.967-6.935-2.699 0-3.998 1.095-3.998 3.516 0 .478.097 1.334.24 2.278l-3.998.477c-.671-.665-1.058-1.42-1.058-2.565 0-3.897 4.334-6.177 9.728-6.177 5.922 0 9.867 2.425 9.867 9.123v10.448c0 2.088.819 3.226 2.265 3.226.324 0 .948-.05 1.544-.157zm18.481-22.64c-3.515 0-5.683 3.33-7.945 7.274l.239-7.274h-1.682l-6.981 2.376v1.139l3.608 1.666v15.911c0 2.186-1.633 2.424-3.848 2.71v1.852h13.479v-1.852c-3.563-.381-4.815-.524-4.815-2.898v-11.403c3.229-3.702 5.247-4.417 8.331-4.417h1.973v-4.419c-.481-.38-1.204-.665-2.359-.665zm-48.355 22.73c-2.939 0-4.428-1.518-4.428-4.938v-14.704h7.51v-2.61h-7.51v-5.419h-1.444c-2.46 3.039-4.528 4.847-7.081 6.366v1.663h3.709v16.296c0 4.892 3.321 6.745 6.978 6.745 2.924 0 4.954-1.291 6.218-2.503-.217-.475-.468-.943-.68-1.501-1.096.433-2.168.605-3.272.605zm-86.689.503c-9.77 0-14.012-8.556-14.012-17.339 0-8.077 3.502-14.824 13.136-14.824 5.53 0 9.241 2.044 11.407 8.316h1.82l-.277-8.075c-2.255-1.376-6.127-3.181-12.626-3.181-10.74 0-19.498 7.595-19.498 19.709 0 9.598 7.054 18.291 19.038 18.291 5.943 0 10.137-1.19 13.964-2.851l1.014-8.981h-1.914c-2.168 5.896-4.909 8.937-12.052 8.937zm38.466-9.027c0-6.129-3.37-11.261-9.147-11.261-4.811 0-7.221 3.803-7.221 8.981 0 6.127 3.371 11.257 9.148 11.257 4.811 0 7.22-3.8 7.22-8.977zm5.107-1.615c0 8.313-6.359 13.538-13.772 13.538-7.606 0-12.806-5.272-12.806-12.589 0-8.314 6.353-13.54 13.767-13.54 7.609 0 12.811 5.273 12.811 12.591zm28.686 2.942c0 6.796-6.391 10.595-14.196 10.595-4.617 0-8.673-1.285-11.08-3.231l-.385-8.885h1.783c1.493 5.135 4.767 9.313 10.446 9.313 5.296 0 8.851-2.468 8.851-6.557 0-3.606-2.881-5.178-6.878-6.743l-5.247-2.043c-4.623-1.805-8.57-3.896-8.57-9.884 0-5.171 5.352-9.969 12.812-9.969 4.342 0 8.418 1.229 10.878 3.131v8.075h-1.686c-1.253-5.13-4.08-8.405-9.67-8.405-4.478 0-7.799 2.322-7.799 6.127 0 3.135 2.209 4.555 5.912 5.983l5.633 2.186c5.342 2.096 9.196 4.181 9.196 10.308z",
        fill: "#0A0B09"
      }));
    }
  },
  costarWheel: {
    size: 37,
    viewBox: '0 0 37 37',
    element: function element() {
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        fillRule: "nonzero"
      }, /*#__PURE__*/React.createElement("path", {
        d: "m 5.1 7.9 l 12.1 3.4 c 0.3 0 0.6 -0.1 0.7 -0.3 l 4.4 -6.1 c 0.2 -0.2 0.1 -0.4 -0.1 -0.6 l -6.2 -4.2 c -0.2 -0.1 -0.6 -0.1 -0.8 0 l -10.1 7.4 c -0.2 0.2 -0.2 0.4 0 0.4 z m 19.7 -5.5 l 0.6 12.6 c 0 0.2 0.2 0.5 0.5 0.6 l 7.1 2.3 c 0.2 0.1 0.5 -0.1 0.6 -0.3 l 2 -7.3 c 0.1 -0.2 0 -0.5 -0.2 -0.7 l -10.2 -7.4 c -0.2 -0.2 -0.4 -0.1 -0.4 0.2 z m 11.4 17.1 l -11.8 4.4 c -0.2 0.1 -0.4 0.4 -0.4 0.6 l 0 7.6 c 0 0.2 0.2 0.4 0.5 0.4 l 7.5 -0.3 c 0.3 0 0.5 -0.2 0.6 -0.4 l 3.9 -12 c 0.1 -0.3 -0.1 -0.4 -0.3 -0.3 z m -12.7 16.1 l -7.8 -9.8 c -0.2 -0.2 -0.5 -0.3 -0.7 -0.2 l -7.2 2.3 c -0.2 0.1 -0.3 0.3 -0.2 0.6 l 2.5 7.1 c 0.1 0.2 0.4 0.4 0.7 0.4 l 12.5 0 c 0.3 0 0.3 -0.2 0.2 -0.4 z m -19.6 -7.2 l -3.9 -12 c -0.1 -0.2 0 -0.5 0.2 -0.7 l 6 -4.7 c 0.2 -0.1 0.4 -0.1 0.6 0.1 l 4.4 6.1 c 0.1 0.2 0.1 0.6 0 0.8 l -6.9 10.5 c -0.1 0.2 -0.3 0.2 -0.4 -0.1 z"
      }));
    }
  },
  poweredByCostar: {
    size: {
      width: 266,
      height: 80
    },
    viewBox: '0 0 266 80',
    element: function element() {
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M10.2709 23.861L34.4467 30.559C34.9313 30.691 35.5514 30.479 35.839 30.078L44.6755 17.896C44.9601 17.482 44.8596 16.915 44.4466 16.627L31.9298 8.19597C31.5217 7.92297 30.8629 7.93696 30.4588 8.22696L10.1326 23.058C9.73051 23.357 9.79321 23.719 10.2709 23.861ZM49.6953 12.771L50.8239 37.941C50.8398 38.44 51.2399 38.967 51.7087 39.121L65.9681 43.8C66.4508 43.944 66.9553 43.668 67.1006 43.19L71.2119 28.622C71.3472 28.151 71.1293 27.521 70.7272 27.227L50.4099 12.384C50.0029 12.095 49.6804 12.266 49.6953 12.771ZM72.3743 47.006L48.8992 55.862C48.4304 56.035 48.0582 56.576 48.0582 57.072L48.0343 72.144C48.0473 72.647 48.4593 73.048 48.9619 73.036L64.0145 72.464C64.5091 72.447 65.0306 72.045 65.1868 71.571L72.9585 47.571C73.1078 47.091 72.841 46.833 72.3743 47.006ZM46.9734 79.265L31.3376 59.566C31.0301 59.173 30.3981 58.98 29.9304 59.132L15.659 63.767C15.1863 63.934 14.9355 64.451 15.1007 64.931L20.2897 79.144C20.4609 79.607 21.0033 79.983 21.5019 79.983L46.6201 80C47.1207 79.993 47.281 79.662 46.9734 79.265ZM7.80279 64.848L0.0530579 40.836C-0.100218 40.361 0.089873 39.728 0.478015 39.422L12.3221 30.065C12.7221 29.761 13.2924 29.841 13.5949 30.243L22.3926 42.445C22.6842 42.846 22.6932 43.507 22.4195 43.924L8.60892 64.957C8.32229 65.369 7.96401 65.321 7.80279 64.848Z",
        fill: "#0054A6"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M259.892 46.1504H260.716V42.4446C260.716 42.2972 260.712 42.0658 260.704 41.7503C260.694 41.4358 260.69 41.2004 260.69 41.0471V40.8552L262.525 46.1504H263.378L265.195 40.8552C265.195 41.1945 265.193 41.5129 265.187 41.8096C265.181 42.1054 265.177 42.317 265.177 42.4446V46.1504H266V39.8731H264.774L262.957 45.1802L261.128 39.8731H259.892V46.1504ZM253.964 39.8731V40.6208H256.107V46.1504H256.978V40.6208H259.123V39.8731H253.964ZM219.99 52.6048L211.566 55.2128C209.879 55.735 208.92 56.6884 208.92 58.4944C208.92 61.2003 210.649 62.577 213.303 62.577C216.137 62.577 217.729 61.3437 219.99 59.6337V52.6048ZM228.613 62.5108C228.782 63.0112 229.094 63.7806 229.217 64.1327C227.705 65.4462 226.281 66 224.662 66C222.158 66 220.908 64.289 220.133 61.676C218.355 63.6244 215.611 66 211.131 66C206.369 66 203.815 63.1971 203.815 59.4913C203.815 55.0714 206.994 54.025 210.701 52.9875L219.99 50.2737V49.2777C219.99 45.382 218.162 42.3427 214.023 42.3427C211.324 42.3427 210.025 43.4376 210.025 45.8587C210.025 46.3364 210.122 47.1929 210.265 48.1364L206.267 48.6131C205.596 47.9485 205.209 47.1929 205.209 46.0486C205.209 42.1518 209.543 39.8712 214.937 39.8712C220.859 39.8712 224.804 42.2962 224.804 48.9939V59.4418C224.804 61.5296 225.623 62.668 227.069 62.668C227.393 62.668 228.017 62.6176 228.613 62.5108ZM247.094 39.8712C243.579 39.8712 241.411 43.2012 239.149 47.1454L239.388 39.8712H237.706L230.725 42.2468V43.3861L234.333 45.0516V60.9629C234.333 63.1487 232.7 63.387 230.485 63.6729V65.5253H243.964V63.6729C240.401 63.2921 239.149 63.1487 239.149 60.775V49.3717C242.378 45.6698 244.396 44.9547 247.48 44.9547H249.453V40.5358C248.972 40.156 248.249 39.8712 247.094 39.8712ZM198.739 62.6008C195.8 62.6008 194.311 61.0826 194.311 57.6626V42.9589H201.821V40.3489H194.311V34.93H192.867C190.407 37.9693 188.339 39.7772 185.786 41.2963V42.9589H189.495V59.2549C189.495 64.1466 192.816 66 196.473 66C199.397 66 201.427 64.7093 202.691 63.4968C202.474 63.0221 202.223 62.5543 202.011 61.9955C200.915 62.4287 199.843 62.6008 198.739 62.6008ZM112.05 63.1042C102.28 63.1042 98.0383 54.5482 98.0383 45.7647C98.0383 37.6874 101.54 30.9404 111.174 30.9404C116.704 30.9404 120.415 32.9846 122.581 39.256H124.401L124.124 31.1807C121.869 29.805 117.997 28 111.498 28C100.758 28 92 35.5947 92 47.7091C92 57.3075 99.0537 66 111.038 66C116.981 66 121.175 64.8102 125.002 63.1487L126.016 54.1674H124.102C121.934 60.0639 119.193 63.1042 112.05 63.1042ZM150.516 54.0774C150.516 47.9485 147.146 42.8165 141.369 42.8165C136.558 42.8165 134.148 46.6192 134.148 51.7977C134.148 57.9247 137.519 63.0547 143.296 63.0547C148.107 63.0547 150.516 59.2549 150.516 54.0774ZM155.623 52.4623C155.623 60.775 149.264 66 141.851 66C134.245 66 129.045 60.7285 129.045 53.4108C129.045 45.0971 135.398 39.8712 142.812 39.8712C150.421 39.8712 155.623 45.1446 155.623 52.4623ZM184.309 55.4047C184.309 62.2002 177.918 66 170.113 66C165.496 66 161.44 64.7153 159.033 62.7689L158.648 53.8836H160.431C161.924 59.0185 165.198 63.1971 170.877 63.1971C176.173 63.1971 179.728 60.7286 179.728 56.64C179.728 53.034 176.847 51.4625 172.85 49.8968L167.603 47.8535C162.98 46.0486 159.033 43.9578 159.033 37.9693C159.033 32.7987 164.385 28 171.845 28C176.187 28 180.263 29.2293 182.723 31.1312V39.2066H181.037C179.784 34.0765 176.957 30.8019 171.367 30.8019C166.889 30.8019 163.568 33.1241 163.568 36.9288C163.568 40.064 165.777 41.4843 169.48 42.9114L175.113 45.0971C180.455 47.1929 184.309 49.2777 184.309 55.4047Z",
        fill: "#0A0B09"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M87.6462 8.29508C88.254 8.29508 88.7885 8.21494 89.2499 8.05465C89.7185 7.89435 90.1103 7.67213 90.4251 7.38798C90.7473 7.09654 90.989 6.75046 91.1501 6.34973C91.3112 5.949 91.3917 5.5082 91.3917 5.02732C91.3917 4.02914 91.0805 3.24954 90.4581 2.68852C89.843 2.1275 88.9057 1.84699 87.6462 1.84699H85.1199V8.29508H87.6462ZM87.6462 0.174865C88.6421 0.174865 89.5061 0.291439 90.2384 0.52459C90.978 0.750456 91.5894 1.07468 92.0727 1.49727C92.556 1.91986 92.9148 2.42987 93.1491 3.02732C93.3908 3.62477 93.5116 4.29144 93.5116 5.02732C93.5116 5.75592 93.3835 6.42259 93.1272 7.02732C92.8709 7.63206 92.4938 8.153 91.9958 8.59016C91.5052 9.02732 90.8938 9.36976 90.1615 9.61749C89.4366 9.85792 88.5981 9.97814 87.6462 9.97814H85.1199V15.8361H83V0.174865H87.6462ZM111.835 8.01093C111.835 9.18397 111.648 10.2623 111.274 11.2459C110.901 12.2222 110.374 13.0638 109.693 13.7705C109.012 14.4772 108.192 15.0273 107.232 15.4208C106.28 15.8069 105.226 16 104.069 16C102.912 16 101.858 15.8069 100.906 15.4208C99.9537 15.0273 99.1372 14.4772 98.4562 13.7705C97.7752 13.0638 97.248 12.2222 96.8745 11.2459C96.5011 10.2623 96.3143 9.18397 96.3143 8.01093C96.3143 6.83789 96.5011 5.76321 96.8745 4.78689C97.248 3.80328 97.7752 2.95811 98.4562 2.25137C99.1372 1.53734 99.9537 0.983605 100.906 0.590163C101.858 0.19672 102.912 0 104.069 0C105.226 0 106.28 0.19672 107.232 0.590163C108.192 0.983605 109.012 1.53734 109.693 2.25137C110.374 2.95811 110.901 3.80328 111.274 4.78689C111.648 5.76321 111.835 6.83789 111.835 8.01093ZM109.649 8.01093C109.649 7.04918 109.517 6.18579 109.253 5.42076C108.99 4.65574 108.616 4.01093 108.133 3.48634C107.65 2.95446 107.064 2.54645 106.376 2.2623C105.687 1.97814 104.918 1.83606 104.069 1.83606C103.227 1.83606 102.462 1.97814 101.773 2.2623C101.085 2.54645 100.496 2.95446 100.005 3.48634C99.5216 4.01093 99.1482 4.65574 98.8846 5.42076C98.621 6.18579 98.4891 7.04918 98.4891 8.01093C98.4891 8.97268 98.621 9.83606 98.8846 10.6011C99.1482 11.3588 99.5216 12.0036 100.005 12.5355C100.496 13.0601 101.085 13.4645 101.773 13.7486C102.462 14.0255 103.227 14.1639 104.069 14.1639C104.918 14.1639 105.687 14.0255 106.376 13.7486C107.064 13.4645 107.65 13.0601 108.133 12.5355C108.616 12.0036 108.99 11.3588 109.253 10.6011C109.517 9.83606 109.649 8.97268 109.649 8.01093ZM136.143 0.174865L131.233 15.8361H129.322L125.335 3.89071C125.298 3.77413 125.262 3.65028 125.225 3.51913C125.196 3.38798 125.163 3.24955 125.126 3.10383C125.089 3.24955 125.053 3.38798 125.016 3.51913C124.98 3.65028 124.943 3.77413 124.906 3.89071L120.897 15.8361H118.986L114.076 0.174865H115.845C116.035 0.174865 116.192 0.222222 116.317 0.316939C116.449 0.411657 116.533 0.531876 116.57 0.677595L119.821 11.5628C119.872 11.7596 119.92 11.9709 119.964 12.1967C120.015 12.4226 120.062 12.663 120.106 12.918C120.158 12.663 120.209 12.4226 120.26 12.1967C120.319 11.9636 120.381 11.7523 120.447 11.5628L124.148 0.677595C124.192 0.553734 124.277 0.440803 124.401 0.338799C124.533 0.22951 124.69 0.174865 124.873 0.174865H125.489C125.679 0.174865 125.833 0.222222 125.95 0.316939C126.067 0.411657 126.155 0.531876 126.213 0.677595L129.904 11.5628C129.97 11.7523 130.029 11.9563 130.08 12.1749C130.138 12.3934 130.193 12.623 130.245 12.8634C130.281 12.623 130.321 12.3934 130.365 12.1749C130.409 11.9563 130.457 11.7523 130.508 11.5628L133.77 0.677595C133.807 0.546448 133.888 0.429873 134.012 0.327869C134.144 0.225866 134.301 0.174865 134.484 0.174865H136.143ZM149.294 14.1093L149.283 15.8361H139.585V0.174865H149.283V1.90164H141.715V7.10382H147.844V8.76503H141.715V14.1093H149.294ZM157.722 7.75956C158.337 7.75956 158.879 7.6867 159.347 7.54098C159.823 7.38798 160.219 7.17668 160.534 6.9071C160.856 6.63024 161.097 6.30237 161.259 5.9235C161.42 5.54463 161.5 5.12568 161.5 4.66667C161.5 3.73406 161.193 3.03096 160.578 2.55738C159.962 2.08379 159.04 1.84699 157.81 1.84699H155.481V7.75956H157.722ZM164.993 15.8361H163.104C162.716 15.8361 162.43 15.6867 162.247 15.388L158.161 9.79235C158.037 9.61748 157.901 9.49363 157.755 9.42077C157.616 9.34062 157.396 9.30055 157.096 9.30055H155.481V15.8361H153.361V0.174865H157.81C158.805 0.174865 159.666 0.276867 160.391 0.480874C161.116 0.677595 161.713 0.965393 162.181 1.34426C162.657 1.72313 163.009 2.18215 163.236 2.72131C163.463 3.25319 163.576 3.85064 163.576 4.51366C163.576 5.0674 163.488 5.5847 163.313 6.06557C163.137 6.54645 162.881 6.97996 162.544 7.36612C162.214 7.74499 161.808 8.06922 161.324 8.3388C160.849 8.60838 160.307 8.81238 159.699 8.95082C159.97 9.10382 160.204 9.32605 160.402 9.61749L164.993 15.8361ZM177.942 14.1093L177.931 15.8361H168.232V0.174865H177.931V1.90164H170.363V7.10382H176.492V8.76503H170.363V14.1093H177.942ZM195.652 8.01093C195.652 9.18397 195.465 10.2514 195.092 11.2131C194.718 12.1749 194.191 12.9982 193.51 13.6831C192.829 14.3679 192.009 14.8998 191.05 15.2787C190.098 15.6503 189.043 15.8361 187.886 15.8361H182.01V0.174865H187.886C189.043 0.174865 190.098 0.3643 191.05 0.743171C192.009 1.11476 192.829 1.64663 193.51 2.3388C194.191 3.02368 194.718 3.84699 195.092 4.80874C195.465 5.77049 195.652 6.83789 195.652 8.01093ZM193.466 8.01093C193.466 7.04918 193.334 6.18944 193.071 5.43169C192.807 4.67395 192.434 4.03279 191.95 3.5082C191.467 2.98361 190.881 2.58288 190.193 2.30601C189.505 2.02915 188.736 1.89071 187.886 1.89071H184.141V14.1202H187.886C188.736 14.1202 189.505 13.9818 190.193 13.7049C190.881 13.4281 191.467 13.031 191.95 12.5137C192.434 11.9891 192.807 11.3479 193.071 10.5902C193.334 9.83242 193.466 8.97268 193.466 8.01093ZM212.064 14.153C212.672 14.153 213.195 14.0838 213.634 13.9454C214.074 13.8069 214.433 13.6138 214.711 13.3661C214.996 13.1111 215.205 12.8124 215.337 12.4699C215.469 12.1202 215.535 11.7377 215.535 11.3224C215.535 10.5137 215.245 9.87614 214.667 9.40984C214.088 8.93625 213.221 8.69945 212.064 8.69945H208.659V14.153H212.064ZM208.659 1.84699V7.19126H211.471C212.071 7.19126 212.591 7.12568 213.03 6.99454C213.477 6.86339 213.843 6.68124 214.129 6.44809C214.422 6.21494 214.638 5.93443 214.777 5.60656C214.916 5.2714 214.985 4.9071 214.985 4.51366C214.985 3.58834 214.707 2.91439 214.151 2.4918C213.594 2.06193 212.73 1.84699 211.558 1.84699H208.659ZM211.558 0.174865C212.525 0.174865 213.356 0.269583 214.052 0.459018C214.755 0.648453 215.33 0.918035 215.776 1.26776C216.23 1.61749 216.563 2.04736 216.776 2.55738C216.988 3.06011 217.094 3.62842 217.094 4.2623C217.094 4.64845 217.032 5.02004 216.908 5.37705C216.79 5.72677 216.611 6.05465 216.369 6.36066C216.128 6.66667 215.82 6.94353 215.447 7.19126C215.081 7.43169 214.649 7.62841 214.151 7.78142C215.308 8 216.175 8.41166 216.754 9.01639C217.34 9.61384 217.633 10.4007 217.633 11.377C217.633 12.0401 217.508 12.6448 217.259 13.1913C217.018 13.7377 216.659 14.2077 216.183 14.6011C215.714 14.9945 215.136 15.3005 214.447 15.5191C213.759 15.7304 212.975 15.8361 212.097 15.8361H206.539V0.174865H211.558ZM227.233 9.59563V15.8361H225.103V9.59563L219.336 0.174865H221.203C221.394 0.174865 221.544 0.222222 221.654 0.316939C221.763 0.404371 221.859 0.520949 221.939 0.666669L225.542 6.7541C225.674 7.00911 225.795 7.24954 225.904 7.47541C226.014 7.69399 226.109 7.91621 226.19 8.14207C226.271 7.91621 226.362 7.69399 226.465 7.47541C226.567 7.24954 226.681 7.00911 226.805 6.7541L230.397 0.666669C230.463 0.542807 230.554 0.429873 230.671 0.327869C230.789 0.225866 230.939 0.174865 231.122 0.174865H233L227.233 9.59563Z",
        fill: "#656565"
      }));
    }
  },
  apartmentsLogo: {
    size: {
      width: 477,
      height: 73
    },
    viewBox: '0 0 477 73',
    element: function element() {
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M8.5 57.6L0.809999 33.6C0.742598 33.3476 0.746143 33.0815 0.820245 32.8309C0.894347 32.5804 1.03613 32.3551 1.23 32.18L13 22.83C13.0929 22.7559 13.1998 22.7014 13.3143 22.6698C13.4288 22.6382 13.5486 22.6301 13.6663 22.6459C13.784 22.6618 13.8973 22.7014 13.9994 22.7622C14.1014 22.8231 14.1901 22.904 14.26 23L23 35.2C23.1372 35.4225 23.2098 35.6787 23.2098 35.94C23.2098 36.2013 23.1372 36.4575 23 36.68L9.28 57.68C9 58.13 8.66 58.08 8.5 57.6ZM47.39 72L31.87 52.33C31.7039 52.1295 31.4834 51.9812 31.235 51.9032C30.9866 51.8251 30.7209 51.8205 30.47 51.89L16.3 56.53C16.0736 56.6114 15.8886 56.7791 15.7856 56.9965C15.6825 57.2139 15.6697 57.4632 15.75 57.69L20.9 71.9C21.001 72.1385 21.1671 72.3438 21.3793 72.4924C21.5916 72.6409 21.8413 72.7267 22.1 72.74H47.04C47.54 72.75 47.7 72.42 47.39 72ZM72.61 39.74L49.3 48.6C49.0614 48.7037 48.8564 48.8719 48.708 49.0856C48.5596 49.2993 48.4737 49.5502 48.46 49.81V64.9C48.4613 65.0195 48.4861 65.1376 48.5331 65.2475C48.58 65.3574 48.6482 65.457 48.7336 65.5406C48.819 65.6241 48.9201 65.6901 49.031 65.7346C49.1419 65.7791 49.2605 65.8013 49.38 65.8L64.32 65.23C64.5791 65.2027 64.8256 65.1042 65.0322 64.9453C65.2387 64.7865 65.3972 64.5735 65.49 64.33L73.2 40.33C73.34 39.85 73.07 39.59 72.61 39.76V39.74ZM50.09 5.52L51.21 30.7C51.2315 30.9593 51.3254 31.2074 51.481 31.416C51.6366 31.6247 51.8476 31.7854 52.09 31.88L66.25 36.56C66.3636 36.5937 66.4827 36.6047 66.6006 36.5923C66.7184 36.5799 66.8326 36.5443 66.9367 36.4876C67.0408 36.4309 67.1326 36.3543 67.207 36.262C67.2813 36.1698 67.3367 36.0637 67.37 35.95L71.46 21.38C71.5183 21.1299 71.5061 20.8686 71.4249 20.625C71.3437 20.3814 71.1967 20.1651 71 20L50.8 5.15C50.4 4.85 50.08 5 50.09 5.52ZM11 16.62L35 23.32C35.2519 23.3784 35.5151 23.3643 35.7593 23.2793C36.0035 23.1944 36.2187 23.0421 36.38 22.84L45.15 10.66C45.286 10.4605 45.3381 10.2155 45.2951 9.9779C45.252 9.74031 45.1173 9.52916 44.92 9.39L32.46 1C32.2432 0.857617 31.9894 0.781754 31.73 0.781754C31.4706 0.781754 31.2168 0.857617 31 1L10.82 15.82C10.42 16.11 10.48 16.48 11 16.62Z",
        fill: "#74B71B"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M110.22 42.93H94.65L92.51 48.48C92.1953 49.1625 92.0154 49.8993 91.98 50.65C91.98 52.29 93.35 52.87 97.12 53.01V55.08H85V53.01C86.53 52.77 87.66 52.48 88.26 51.01L100.65 20.51L99.04 17H105.19L119.38 51C119.97 52.45 121.11 52.74 122.63 53V55.07H107.94V53C111.7 52.86 113 52.32 113.03 50.69C113.009 49.9373 112.829 49.1976 112.5 48.52L110.22 42.93ZM95.73 40.28H109.12L102.28 23.51L95.73 40.28ZM130.93 53.68V62.01C130.93 64.21 132.55 64.45 134.72 64.74V66.61H122.42V64.74C124.6 64.45 126.2 64.21 126.2 62.01V34.48L122.65 32.8V31.65L129.51 29.26H131.16L130.92 33.71C131.988 32.3377 133.352 31.2246 134.91 30.4539C136.469 29.6833 138.181 29.2752 139.92 29.26C147.21 29.26 151.04 34.62 151.04 41.26C151.04 50.12 144.89 55.63 137.42 55.63C135.102 55.7025 132.824 55.018 130.93 53.68V53.68ZM146.22 43.24C146.22 38.24 144.28 32.9 138.22 32.9C135.483 32.9525 132.879 34.0891 130.98 36.06V46.84C130.98 51.38 134.44 52.84 138.04 52.84C142.95 52.87 146.22 49.42 146.22 43.24ZM174.54 48.85C174.54 50.95 175.54 52.1 176.94 52.1C177.463 52.0893 177.98 51.9912 178.47 51.81L178.94 53.3C177.29 54.93 175.87 55.6 174.29 55.6C171.83 55.6 170.71 53.87 169.95 51.24C168.891 52.5783 167.548 53.664 166.017 54.4182C164.486 55.1724 162.806 55.5761 161.1 55.6C156.42 55.6 153.91 52.77 153.91 49.04C153.91 44.58 157.03 43.53 160.67 42.48L169.81 39.75V38.75C169.81 34.82 168.01 31.75 163.94 31.75C161.29 31.75 160.01 32.85 160.01 35.29C160.044 36.0607 160.124 36.8288 160.25 37.59L156.32 38.07C155.982 37.7337 155.719 37.3304 155.547 36.886C155.374 36.4416 155.297 35.966 155.32 35.49C155.32 31.56 159.58 29.26 164.88 29.26C170.7 29.26 174.58 31.7 174.58 38.45L174.54 48.85ZM169.81 49.18V42.09L161.53 44.73C160.77 44.8719 160.088 45.2846 159.61 45.8915C159.132 46.4985 158.89 47.2583 158.93 48.03C158.93 50.76 160.63 52.15 163.23 52.15C166.02 52.15 167.58 50.9 169.81 49.18ZM189.38 35.52C191.61 31.52 193.56 29.26 196.44 29.26C197.268 29.2079 198.088 29.4447 198.76 29.93V33.62H196.82C194.82 33.62 192.55 34.03 189.38 37.76V50.34C189.38 52.73 190.62 52.88 194.12 53.26V55.13H180.87V53.26C183.05 52.97 184.65 52.73 184.65 50.53V34.53L181.1 32.85V31.65L187.96 29.26H189.65L189.38 35.52ZM208.57 29.74H215.95V32.34H208.57V47.09C208.57 50.54 210.04 52.09 212.93 52.09C213.954 52.1055 214.971 51.9291 215.93 51.57L216.5 52.91C215.687 53.7744 214.702 54.4593 213.608 54.9208C212.515 55.3823 211.337 55.6102 210.15 55.59C206.87 55.59 203.85 53.72 203.85 48.79V32.34H201.34V30.7C203.85 29.16 204.75 27.34 207.16 24.28H208.58L208.57 29.74ZM325.95 29.74H333.33V32.34H325.95V47.09C325.95 50.54 327.42 52.09 330.3 52.09C331.324 52.1064 332.341 51.93 333.3 51.57L333.87 52.91C333.058 53.7759 332.073 54.4617 330.979 54.9234C329.885 55.385 328.707 55.6121 327.52 55.59C324.25 55.59 321.23 53.72 321.23 48.79V32.34H318.72V30.7C321.22 29.16 322.13 27.34 324.54 24.28H325.96L325.95 29.74ZM251.65 29.26C256.29 29.26 259.18 32.04 259.18 36.54V50.54C259.18 52.74 260.79 52.98 262.97 53.27V55.14H250.7V53.27C252.88 52.98 254.49 52.74 254.49 50.54V37.78C254.49 34.62 252.83 33.14 249.8 33.14C247.285 33.2555 244.891 34.254 243.04 35.96V50.52C243.04 52.72 244.65 52.96 246.82 53.25V55.12H234.52V53.25C236.7 52.96 238.3 52.72 238.3 50.52V37.78C238.3 34.62 236.65 33.14 233.62 33.14C231.105 33.2555 228.711 34.254 226.86 35.96V50.52C226.86 52.72 228.46 52.96 230.64 53.25V55.12H218.34V53.25C220.52 52.96 222.12 52.72 222.12 50.52V34.52L218.58 32.84V31.65L225.44 29.26H227.09L226.86 33.81C227.89 32.4716 229.197 31.3719 230.692 30.5865C232.186 29.8011 233.834 29.3485 235.52 29.26C239.2 29.26 241.85 30.98 242.75 34C243.801 32.6115 245.141 31.4683 246.678 30.6498C248.215 29.8313 249.911 29.357 251.65 29.26V29.26ZM287.13 39.41V40.75H268.65C268.65 47.36 271.48 51.43 277.73 51.43C279.286 51.4707 280.831 51.1506 282.243 50.4949C283.656 49.8391 284.897 48.8654 285.87 47.65L287.24 48.27C286.24 51.77 282.93 55.6 276.24 55.6C268.63 55.6 264.13 50.09 264.13 43.24C264.13 34.86 269.43 29.24 276.67 29.24C283.58 29.26 287.17 33.67 287.17 39.41H287.13ZM268.73 38.41H281.93C281.93 35.06 279.7 32.28 275.44 32.28C271.75 32.23 269.29 34.77 268.77 38.34L268.73 38.41ZM310.23 37.83C310.23 34.29 308.38 33.19 305.23 33.19C302.382 33.3585 299.657 34.4067 297.43 36.19V50.6C297.43 52.8 299.04 53.04 301.21 53.33V55.2H288.91V53.33C291.09 53.04 292.7 52.8 292.7 50.6V34.6L289.15 32.92V31.65L296.01 29.26H297.66L297.43 33.95C299.51 31.65 303.29 29.26 307.03 29.26C311.67 29.26 314.93 31.51 314.93 37.11V50.52C314.93 52.72 316.54 52.96 318.72 53.25V55.12H306.42V53.25C308.59 52.96 310.2 52.72 310.2 50.52L310.23 37.83ZM335.65 53.1L335.36 46.74H337.36C338.36 50.85 340.58 53.06 344.5 53.06C347.82 53.06 349.8 51.58 349.8 48.8C349.8 46.5 348.2 45.59 345.5 44.8L342.19 43.75C338.19 42.51 335.75 40.88 335.75 36.52C335.75 32.16 339.16 29.29 344.5 29.29C347.353 29.2134 350.173 29.9226 352.65 31.34V37.28H350.65C349.9 33.4 347.86 31.82 344.36 31.82C341.81 31.82 340.01 33.02 340.01 35.51C340.01 37.51 341.15 38.38 343.51 39.14L347.25 40.29C351.7 41.63 354.11 43.45 354.11 48C354.11 52.74 350.28 55.62 344.5 55.62C341.359 55.7279 338.263 54.8464 335.65 53.1V53.1ZM361.24 49.34C361.863 49.3321 362.474 49.5095 362.995 49.8496C363.517 50.1898 363.926 50.6774 364.169 51.2504C364.413 51.8234 364.481 52.456 364.364 53.0677C364.248 53.6794 363.952 54.2426 363.514 54.6858C363.077 55.1289 362.518 55.432 361.907 55.5564C361.297 55.6808 360.664 55.621 360.088 55.3846C359.512 55.1482 359.019 54.7458 358.672 54.2286C358.325 53.7114 358.14 53.1027 358.14 52.48C358.135 52.0695 358.211 51.6621 358.364 51.2814C358.518 50.9006 358.745 50.5542 359.034 50.2621C359.322 49.97 359.666 49.738 360.044 49.5797C360.423 49.4214 360.83 49.34 361.24 49.34V49.34ZM380.24 51.44C381.8 51.4795 383.348 51.1581 384.764 50.5006C386.179 49.8432 387.424 48.8676 388.4 47.65L389.77 48.27C388.77 51.77 385.46 55.61 378.77 55.61C370.58 55.61 366.69 49.37 366.69 43.24C366.69 34.75 372.47 29.24 380.34 29.24C385.84 29.24 389.25 31.93 389.25 35.48C389.281 36.1174 389.121 36.7496 388.792 37.2962C388.462 37.8428 387.978 38.2792 387.4 38.55H384.18V36.55C384.18 33.55 382.8 31.99 379.39 31.99C374.65 31.99 371.24 35.4 371.24 41.39C371.22 47.59 374.35 51.43 380.22 51.43L380.24 51.44ZM392.31 42.9C392.247 41.0979 392.553 39.3019 393.21 37.6227C393.867 35.9434 394.86 34.4164 396.13 33.1358C397.399 31.8551 398.917 30.8479 400.591 30.1762C402.264 29.5045 404.057 29.1825 405.86 29.23C413.35 29.23 418.47 34.56 418.47 41.94C418.533 43.7421 418.227 45.538 417.57 47.2173C416.913 48.8966 415.92 50.4235 414.65 51.7042C413.381 52.9848 411.863 53.9921 410.189 54.6638C408.516 55.3355 406.723 55.6575 404.92 55.61C397.41 55.6 392.29 50.28 392.29 42.89L392.31 42.9ZM413.45 43.57C413.45 37.39 410.13 32.21 404.45 32.21C399.72 32.21 397.35 36.04 397.35 41.27C397.35 47.46 400.66 52.64 406.35 52.64C411.06 52.63 413.43 48.79 413.43 43.56L413.45 43.57ZM453.34 29.23C457.99 29.23 460.88 32.01 460.88 36.52V50.52C460.88 52.72 462.49 52.96 464.67 53.25V55.12H452.33V53.25C454.51 52.96 456.12 52.72 456.12 50.52V37.76C456.12 34.59 454.46 33.11 451.43 33.11C448.91 33.2293 446.511 34.227 444.65 35.93V50.52C444.65 52.72 446.26 52.96 448.44 53.25V55.12H436.12V53.25C438.3 52.96 439.91 52.72 439.91 50.52V37.76C439.91 34.59 438.26 33.11 435.22 33.11C432.703 33.2299 430.308 34.2277 428.45 35.93V50.52C428.45 52.72 430.06 52.96 432.24 53.25V55.12H419.92V53.25C422.1 52.96 423.71 52.72 423.71 50.52V34.45L420.15 32.77V31.62L427.02 29.22H428.65L428.42 33.78C429.45 32.4385 430.758 31.3361 432.255 30.5489C433.752 29.7617 435.401 29.3083 437.09 29.22C440.78 29.22 443.44 30.95 444.34 33.97C445.398 32.5697 446.751 31.4186 448.303 30.5978C449.854 29.7771 451.567 29.3068 453.32 29.22L453.34 29.23ZM469.82 29.75V30.51H467.65V36.1H466.78V30.5H464.65V29.74L469.82 29.75ZM470.58 29.75H471.82L473.65 35.1L475.46 29.74H476.65V36.09H475.83V32.34C475.83 32.21 475.83 32 475.83 31.7V30.7L474.02 36.06H473.17L471.34 30.7V30.9C471.34 31.05 471.34 31.29 471.34 31.61C471.34 31.93 471.34 32.16 471.34 32.31V36.06H470.52L470.58 29.75Z",
        fill: "black"
      }));
    }
  },
  poweredByApartments: {
    size: {
      width: 477,
      height: 81
    },
    viewBox: '0 0 477 81',
    element: function element() {
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M8.5 65.6L0.809999 41.6C0.742598 41.3476 0.746143 41.0815 0.820245 40.8309C0.894347 40.5804 1.03613 40.3551 1.23 40.18L13 30.83C13.0929 30.7559 13.1998 30.7014 13.3143 30.6698C13.4288 30.6382 13.5486 30.6301 13.6663 30.6459C13.784 30.6618 13.8973 30.7014 13.9994 30.7622C14.1014 30.8231 14.1901 30.904 14.26 31L23 43.2C23.1372 43.4225 23.2098 43.6787 23.2098 43.94C23.2098 44.2013 23.1372 44.4575 23 44.68L9.28 65.68C9 66.13 8.66 66.08 8.5 65.6ZM47.39 80L31.87 60.33C31.7039 60.1295 31.4834 59.9812 31.235 59.9032C30.9866 59.8251 30.7209 59.8205 30.47 59.89L16.3 64.53C16.0736 64.6114 15.8886 64.7791 15.7856 64.9965C15.6825 65.2139 15.6697 65.4632 15.75 65.69L20.9 79.9C21.001 80.1385 21.1671 80.3438 21.3793 80.4924C21.5916 80.6409 21.8413 80.7267 22.1 80.74H47.04C47.54 80.75 47.7 80.42 47.39 80ZM72.61 47.74L49.3 56.6C49.0614 56.7037 48.8564 56.8719 48.708 57.0856C48.5596 57.2993 48.4737 57.5502 48.46 57.81V72.9C48.4613 73.0195 48.4861 73.1376 48.5331 73.2475C48.58 73.3574 48.6482 73.457 48.7336 73.5406C48.819 73.6241 48.9201 73.6901 49.031 73.7346C49.1419 73.7791 49.2605 73.8013 49.38 73.8L64.32 73.23C64.5791 73.2027 64.8256 73.1042 65.0322 72.9453C65.2387 72.7865 65.3972 72.5735 65.49 72.33L73.2 48.33C73.34 47.85 73.07 47.59 72.61 47.76V47.74ZM50.09 13.52L51.21 38.7C51.2315 38.9593 51.3254 39.2074 51.481 39.416C51.6366 39.6247 51.8476 39.7854 52.09 39.88L66.25 44.56C66.3636 44.5937 66.4827 44.6047 66.6006 44.5923C66.7184 44.5799 66.8326 44.5443 66.9367 44.4876C67.0408 44.4309 67.1326 44.3543 67.207 44.262C67.2813 44.1698 67.3367 44.0637 67.37 43.95L71.46 29.38C71.5183 29.1299 71.5061 28.8686 71.4249 28.625C71.3437 28.3814 71.1967 28.1651 71 28L50.8 13.15C50.4 12.85 50.08 13 50.09 13.52ZM11 24.62L35 31.32C35.2519 31.3784 35.5151 31.3643 35.7593 31.2793C36.0035 31.1944 36.2187 31.0421 36.38 30.84L45.15 18.66C45.286 18.4605 45.3381 18.2155 45.2951 17.9779C45.252 17.7403 45.1173 17.5292 44.92 17.39L32.46 9C32.2432 8.85762 31.9894 8.78175 31.73 8.78175C31.4706 8.78175 31.2168 8.85762 31 9L10.82 23.82C10.42 24.11 10.48 24.48 11 24.62Z",
        fill: "#74B71B"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M110.22 50.93H94.65L92.51 56.48C92.1953 57.1625 92.0154 57.8993 91.98 58.65C91.98 60.29 93.35 60.87 97.12 61.01V63.08H85V61.01C86.53 60.77 87.66 60.48 88.26 59.01L100.65 28.51L99.04 25H105.19L119.38 59C119.97 60.45 121.11 60.74 122.63 61V63.07H107.94V61C111.7 60.86 113 60.32 113.03 58.69C113.009 57.9373 112.829 57.1976 112.5 56.52L110.22 50.93ZM95.73 48.28H109.12L102.28 31.51L95.73 48.28ZM130.93 61.68V70.01C130.93 72.21 132.55 72.45 134.72 72.74V74.61H122.42V72.74C124.6 72.45 126.2 72.21 126.2 70.01V42.48L122.65 40.8V39.65L129.51 37.26H131.16L130.92 41.71C131.988 40.3377 133.352 39.2246 134.91 38.4539C136.469 37.6833 138.181 37.2752 139.92 37.26C147.21 37.26 151.04 42.62 151.04 49.26C151.04 58.12 144.89 63.63 137.42 63.63C135.102 63.7025 132.824 63.018 130.93 61.68V61.68ZM146.22 51.24C146.22 46.24 144.28 40.9 138.22 40.9C135.483 40.9525 132.879 42.0891 130.98 44.06V54.84C130.98 59.38 134.44 60.84 138.04 60.84C142.95 60.87 146.22 57.42 146.22 51.24ZM174.54 56.85C174.54 58.95 175.54 60.1 176.94 60.1C177.463 60.0893 177.98 59.9912 178.47 59.81L178.94 61.3C177.29 62.93 175.87 63.6 174.29 63.6C171.83 63.6 170.71 61.87 169.95 59.24C168.891 60.5783 167.548 61.664 166.017 62.4182C164.486 63.1724 162.806 63.5761 161.1 63.6C156.42 63.6 153.91 60.77 153.91 57.04C153.91 52.58 157.03 51.53 160.67 50.48L169.81 47.75V46.75C169.81 42.82 168.01 39.75 163.94 39.75C161.29 39.75 160.01 40.85 160.01 43.29C160.044 44.0607 160.124 44.8288 160.25 45.59L156.32 46.07C155.982 45.7337 155.719 45.3304 155.547 44.886C155.374 44.4416 155.297 43.966 155.32 43.49C155.32 39.56 159.58 37.26 164.88 37.26C170.7 37.26 174.58 39.7 174.58 46.45L174.54 56.85ZM169.81 57.18V50.09L161.53 52.73C160.77 52.8719 160.088 53.2846 159.61 53.8915C159.132 54.4985 158.89 55.2583 158.93 56.03C158.93 58.76 160.63 60.15 163.23 60.15C166.02 60.15 167.58 58.9 169.81 57.18ZM189.38 43.52C191.61 39.52 193.56 37.26 196.44 37.26C197.268 37.2079 198.088 37.4447 198.76 37.93V41.62H196.82C194.82 41.62 192.55 42.03 189.38 45.76V58.34C189.38 60.73 190.62 60.88 194.12 61.26V63.13H180.87V61.26C183.05 60.97 184.65 60.73 184.65 58.53V42.53L181.1 40.85V39.65L187.96 37.26H189.65L189.38 43.52ZM208.57 37.74H215.95V40.34H208.57V55.09C208.57 58.54 210.04 60.09 212.93 60.09C213.954 60.1055 214.971 59.9291 215.93 59.57L216.5 60.91C215.687 61.7744 214.702 62.4593 213.608 62.9208C212.515 63.3823 211.337 63.6102 210.15 63.59C206.87 63.59 203.85 61.72 203.85 56.79V40.34H201.34V38.7C203.85 37.16 204.75 35.34 207.16 32.28H208.58L208.57 37.74ZM325.95 37.74H333.33V40.34H325.95V55.09C325.95 58.54 327.42 60.09 330.3 60.09C331.324 60.1064 332.341 59.93 333.3 59.57L333.87 60.91C333.058 61.7759 332.073 62.4617 330.979 62.9234C329.885 63.385 328.707 63.6121 327.52 63.59C324.25 63.59 321.23 61.72 321.23 56.79V40.34H318.72V38.7C321.22 37.16 322.13 35.34 324.54 32.28H325.96L325.95 37.74ZM251.65 37.26C256.29 37.26 259.18 40.04 259.18 44.54V58.54C259.18 60.74 260.79 60.98 262.97 61.27V63.14H250.7V61.27C252.88 60.98 254.49 60.74 254.49 58.54V45.78C254.49 42.62 252.83 41.14 249.8 41.14C247.285 41.2555 244.891 42.254 243.04 43.96V58.52C243.04 60.72 244.65 60.96 246.82 61.25V63.12H234.52V61.25C236.7 60.96 238.3 60.72 238.3 58.52V45.78C238.3 42.62 236.65 41.14 233.62 41.14C231.105 41.2555 228.711 42.254 226.86 43.96V58.52C226.86 60.72 228.46 60.96 230.64 61.25V63.12H218.34V61.25C220.52 60.96 222.12 60.72 222.12 58.52V42.52L218.58 40.84V39.65L225.44 37.26H227.09L226.86 41.81C227.89 40.4716 229.197 39.3719 230.692 38.5865C232.186 37.8011 233.834 37.3485 235.52 37.26C239.2 37.26 241.85 38.98 242.75 42C243.801 40.6115 245.141 39.4683 246.678 38.6498C248.215 37.8313 249.911 37.357 251.65 37.26V37.26ZM287.13 47.41V48.75H268.65C268.65 55.36 271.48 59.43 277.73 59.43C279.286 59.4707 280.831 59.1506 282.243 58.4949C283.656 57.8391 284.897 56.8654 285.87 55.65L287.24 56.27C286.24 59.77 282.93 63.6 276.24 63.6C268.63 63.6 264.13 58.09 264.13 51.24C264.13 42.86 269.43 37.24 276.67 37.24C283.58 37.26 287.17 41.67 287.17 47.41H287.13ZM268.73 46.41H281.93C281.93 43.06 279.7 40.28 275.44 40.28C271.75 40.23 269.29 42.77 268.77 46.34L268.73 46.41ZM310.23 45.83C310.23 42.29 308.38 41.19 305.23 41.19C302.382 41.3585 299.657 42.4067 297.43 44.19V58.6C297.43 60.8 299.04 61.04 301.21 61.33V63.2H288.91V61.33C291.09 61.04 292.7 60.8 292.7 58.6V42.6L289.15 40.92V39.65L296.01 37.26H297.66L297.43 41.95C299.51 39.65 303.29 37.26 307.03 37.26C311.67 37.26 314.93 39.51 314.93 45.11V58.52C314.93 60.72 316.54 60.96 318.72 61.25V63.12H306.42V61.25C308.59 60.96 310.2 60.72 310.2 58.52L310.23 45.83ZM335.65 61.1L335.36 54.74H337.36C338.36 58.85 340.58 61.06 344.5 61.06C347.82 61.06 349.8 59.58 349.8 56.8C349.8 54.5 348.2 53.59 345.5 52.8L342.19 51.75C338.19 50.51 335.75 48.88 335.75 44.52C335.75 40.16 339.16 37.29 344.5 37.29C347.353 37.2134 350.173 37.9226 352.65 39.34V45.28H350.65C349.9 41.4 347.86 39.82 344.36 39.82C341.81 39.82 340.01 41.02 340.01 43.51C340.01 45.51 341.15 46.38 343.51 47.14L347.25 48.29C351.7 49.63 354.11 51.45 354.11 56C354.11 60.74 350.28 63.62 344.5 63.62C341.359 63.7279 338.263 62.8464 335.65 61.1V61.1ZM361.24 57.34C361.863 57.3321 362.474 57.5095 362.995 57.8496C363.517 58.1898 363.926 58.6774 364.169 59.2504C364.413 59.8234 364.481 60.456 364.364 61.0677C364.248 61.6794 363.952 62.2426 363.514 62.6858C363.077 63.1289 362.518 63.432 361.907 63.5564C361.297 63.6808 360.664 63.621 360.088 63.3846C359.512 63.1482 359.019 62.7458 358.672 62.2286C358.325 61.7114 358.14 61.1027 358.14 60.48C358.135 60.0695 358.211 59.6621 358.364 59.2814C358.518 58.9006 358.745 58.5542 359.034 58.2621C359.322 57.97 359.666 57.738 360.044 57.5797C360.423 57.4214 360.83 57.34 361.24 57.34V57.34ZM380.24 59.44C381.8 59.4795 383.348 59.1581 384.764 58.5006C386.179 57.8432 387.424 56.8676 388.4 55.65L389.77 56.27C388.77 59.77 385.46 63.61 378.77 63.61C370.58 63.61 366.69 57.37 366.69 51.24C366.69 42.75 372.47 37.24 380.34 37.24C385.84 37.24 389.25 39.93 389.25 43.48C389.281 44.1174 389.121 44.7496 388.792 45.2962C388.462 45.8428 387.978 46.2792 387.4 46.55H384.18V44.55C384.18 41.55 382.8 39.99 379.39 39.99C374.65 39.99 371.24 43.4 371.24 49.39C371.22 55.59 374.35 59.43 380.22 59.43L380.24 59.44ZM392.31 50.9C392.247 49.0979 392.553 47.3019 393.21 45.6227C393.867 43.9434 394.86 42.4164 396.13 41.1358C397.399 39.8551 398.917 38.8479 400.591 38.1762C402.264 37.5045 404.057 37.1825 405.86 37.23C413.35 37.23 418.47 42.56 418.47 49.94C418.533 51.7421 418.227 53.538 417.57 55.2173C416.913 56.8966 415.92 58.4235 414.65 59.7042C413.381 60.9848 411.863 61.9921 410.189 62.6638C408.516 63.3355 406.723 63.6575 404.92 63.61C397.41 63.6 392.29 58.28 392.29 50.89L392.31 50.9ZM413.45 51.57C413.45 45.39 410.13 40.21 404.45 40.21C399.72 40.21 397.35 44.04 397.35 49.27C397.35 55.46 400.66 60.64 406.35 60.64C411.06 60.63 413.43 56.79 413.43 51.56L413.45 51.57ZM453.34 37.23C457.99 37.23 460.88 40.01 460.88 44.52V58.52C460.88 60.72 462.49 60.96 464.67 61.25V63.12H452.33V61.25C454.51 60.96 456.12 60.72 456.12 58.52V45.76C456.12 42.59 454.46 41.11 451.43 41.11C448.91 41.2293 446.511 42.227 444.65 43.93V58.52C444.65 60.72 446.26 60.96 448.44 61.25V63.12H436.12V61.25C438.3 60.96 439.91 60.72 439.91 58.52V45.76C439.91 42.59 438.26 41.11 435.22 41.11C432.703 41.2299 430.308 42.2277 428.45 43.93V58.52C428.45 60.72 430.06 60.96 432.24 61.25V63.12H419.92V61.25C422.1 60.96 423.71 60.72 423.71 58.52V42.45L420.15 40.77V39.62L427.02 37.22H428.65L428.42 41.78C429.45 40.4385 430.758 39.3361 432.255 38.5489C433.752 37.7617 435.401 37.3083 437.09 37.22C440.78 37.22 443.44 38.95 444.34 41.97C445.398 40.5697 446.751 39.4186 448.303 38.5978C449.854 37.7771 451.567 37.3068 453.32 37.22L453.34 37.23ZM469.82 37.75V38.51H467.65V44.1H466.78V38.5H464.65V37.74L469.82 37.75ZM470.58 37.75H471.82L473.65 43.1L475.46 37.74H476.65V44.09H475.83V40.34C475.83 40.21 475.83 40 475.83 39.7V38.7L474.02 44.06H473.17L471.34 38.7V38.9C471.34 39.05 471.34 39.29 471.34 39.61C471.34 39.93 471.34 40.16 471.34 40.31V44.06H470.52L470.58 37.75Z",
        fill: "black"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M90.076 9.108C90.74 9.108 91.324 9.02 91.828 8.844C92.34 8.668 92.768 8.424 93.112 8.112C93.464 7.792 93.728 7.412 93.904 6.972C94.08 6.532 94.168 6.048 94.168 5.52C94.168 4.424 93.828 3.568 93.148 2.952C92.476 2.336 91.452 2.028 90.076 2.028H87.316V9.108H90.076ZM90.076 0.192001C91.164 0.192001 92.108 0.32 92.908 0.576C93.716 0.824 94.384 1.18 94.912 1.644C95.44 2.108 95.832 2.668 96.088 3.324C96.352 3.98 96.484 4.712 96.484 5.52C96.484 6.32 96.344 7.052 96.064 7.716C95.784 8.38 95.372 8.952 94.828 9.432C94.292 9.912 93.624 10.288 92.824 10.56C92.032 10.824 91.116 10.956 90.076 10.956H87.316V17.388H85V0.192001H90.076ZM116.502 8.796C116.502 10.084 116.298 11.268 115.89 12.348C115.482 13.42 114.906 14.344 114.162 15.12C113.418 15.896 112.522 16.5 111.474 16.932C110.434 17.356 109.282 17.568 108.018 17.568C106.754 17.568 105.602 17.356 104.562 16.932C103.522 16.5 102.63 15.896 101.886 15.12C101.142 14.344 100.566 13.42 100.158 12.348C99.75 11.268 99.546 10.084 99.546 8.796C99.546 7.508 99.75 6.328 100.158 5.256C100.566 4.176 101.142 3.248 101.886 2.472C102.63 1.688 103.522 1.08 104.562 0.647999C105.602 0.215999 106.754 0 108.018 0C109.282 0 110.434 0.215999 111.474 0.647999C112.522 1.08 113.418 1.688 114.162 2.472C114.906 3.248 115.482 4.176 115.89 5.256C116.298 6.328 116.502 7.508 116.502 8.796ZM114.114 8.796C114.114 7.74 113.97 6.792 113.682 5.952C113.394 5.112 112.986 4.404 112.458 3.828C111.93 3.244 111.29 2.796 110.538 2.484C109.786 2.172 108.946 2.016 108.018 2.016C107.098 2.016 106.262 2.172 105.51 2.484C104.758 2.796 104.114 3.244 103.578 3.828C103.05 4.404 102.642 5.112 102.354 5.952C102.066 6.792 101.922 7.74 101.922 8.796C101.922 9.852 102.066 10.8 102.354 11.64C102.642 12.472 103.05 13.18 103.578 13.764C104.114 14.34 104.758 14.784 105.51 15.096C106.262 15.4 107.098 15.552 108.018 15.552C108.946 15.552 109.786 15.4 110.538 15.096C111.29 14.784 111.93 14.34 112.458 13.764C112.986 13.18 113.394 12.472 113.682 11.64C113.97 10.8 114.114 9.852 114.114 8.796ZM143.059 0.192001L137.695 17.388H135.607L131.251 4.272C131.211 4.144 131.171 4.008 131.131 3.864C131.099 3.72 131.063 3.568 131.023 3.408C130.983 3.568 130.943 3.72 130.903 3.864C130.863 4.008 130.823 4.144 130.783 4.272L126.403 17.388H124.315L118.951 0.192001H120.883C121.091 0.192001 121.263 0.244 121.399 0.348C121.543 0.452 121.635 0.583999 121.675 0.743999L125.227 12.696C125.283 12.912 125.335 13.144 125.383 13.392C125.439 13.64 125.491 13.904 125.539 14.184C125.595 13.904 125.651 13.64 125.707 13.392C125.771 13.136 125.839 12.904 125.911 12.696L129.955 0.743999C130.003 0.607999 130.095 0.484002 130.231 0.372002C130.375 0.252002 130.547 0.192001 130.747 0.192001H131.419C131.627 0.192001 131.795 0.244 131.923 0.348C132.051 0.452 132.147 0.583999 132.211 0.743999L136.243 12.696C136.315 12.904 136.379 13.128 136.435 13.368C136.499 13.608 136.559 13.86 136.615 14.124C136.655 13.86 136.699 13.608 136.747 13.368C136.795 13.128 136.847 12.904 136.903 12.696L140.467 0.743999C140.507 0.599999 140.595 0.472001 140.731 0.360001C140.875 0.248001 141.047 0.192001 141.247 0.192001H143.059ZM157.427 15.492L157.415 17.388H146.819V0.192001H157.415V2.088H149.147V7.8H155.843V9.624H149.147V15.492H157.427ZM166.634 8.52C167.306 8.52 167.898 8.44 168.41 8.28C168.93 8.112 169.362 7.88 169.706 7.584C170.058 7.28 170.322 6.92 170.498 6.504C170.674 6.088 170.762 5.628 170.762 5.124C170.762 4.1 170.426 3.328 169.754 2.808C169.082 2.288 168.074 2.028 166.73 2.028H164.186V8.52H166.634ZM174.578 17.388H172.514C172.09 17.388 171.778 17.224 171.578 16.896L167.114 10.752C166.978 10.56 166.83 10.424 166.67 10.344C166.518 10.256 166.278 10.212 165.95 10.212H164.186V17.388H161.87V0.192001H166.73C167.818 0.192001 168.758 0.304 169.55 0.528C170.342 0.744 170.994 1.06 171.506 1.476C172.026 1.892 172.41 2.396 172.658 2.988C172.906 3.572 173.03 4.228 173.03 4.956C173.03 5.564 172.934 6.132 172.742 6.66C172.55 7.188 172.27 7.664 171.902 8.088C171.542 8.504 171.098 8.86 170.57 9.156C170.05 9.452 169.458 9.676 168.794 9.828C169.09 9.996 169.346 10.24 169.562 10.56L174.578 17.388ZM188.725 15.492L188.713 17.388H178.117V0.192001H188.713V2.088H180.445V7.8H187.141V9.624H180.445V15.492H188.725ZM208.073 8.796C208.073 10.084 207.869 11.256 207.461 12.312C207.053 13.368 206.477 14.272 205.733 15.024C204.989 15.776 204.093 16.36 203.045 16.776C202.005 17.184 200.853 17.388 199.589 17.388H193.169V0.192001H199.589C200.853 0.192001 202.005 0.400002 203.045 0.816002C204.093 1.224 204.989 1.808 205.733 2.568C206.477 3.32 207.053 4.224 207.461 5.28C207.869 6.336 208.073 7.508 208.073 8.796ZM205.685 8.796C205.685 7.74 205.541 6.796 205.253 5.964C204.965 5.132 204.557 4.428 204.029 3.852C203.501 3.276 202.861 2.836 202.109 2.532C201.357 2.228 200.517 2.076 199.589 2.076H195.497V15.504H199.589C200.517 15.504 201.357 15.352 202.109 15.048C202.861 14.744 203.501 14.308 204.029 13.74C204.557 13.164 204.965 12.46 205.253 11.628C205.541 10.796 205.685 9.852 205.685 8.796ZM226.003 15.54C226.667 15.54 227.239 15.464 227.719 15.312C228.199 15.16 228.591 14.948 228.895 14.676C229.207 14.396 229.435 14.068 229.579 13.692C229.723 13.308 229.795 12.888 229.795 12.432C229.795 11.544 229.479 10.844 228.847 10.332C228.215 9.812 227.267 9.552 226.003 9.552H222.283V15.54H226.003ZM222.283 2.028V7.896H225.355C226.011 7.896 226.579 7.824 227.059 7.68C227.547 7.536 227.947 7.336 228.259 7.08C228.579 6.824 228.815 6.516 228.967 6.156C229.119 5.788 229.195 5.388 229.195 4.956C229.195 3.94 228.891 3.2 228.283 2.736C227.675 2.264 226.731 2.028 225.451 2.028H222.283ZM225.451 0.192001C226.507 0.192001 227.415 0.296002 228.175 0.504002C228.943 0.712002 229.571 1.008 230.059 1.392C230.555 1.776 230.919 2.248 231.151 2.808C231.383 3.36 231.499 3.984 231.499 4.68C231.499 5.104 231.431 5.512 231.295 5.904C231.167 6.288 230.971 6.648 230.707 6.984C230.443 7.32 230.107 7.624 229.699 7.896C229.299 8.16 228.827 8.376 228.283 8.544C229.547 8.784 230.495 9.236 231.127 9.9C231.767 10.556 232.087 11.42 232.087 12.492C232.087 13.22 231.951 13.884 231.679 14.484C231.415 15.084 231.023 15.6 230.503 16.032C229.991 16.464 229.359 16.8 228.607 17.04C227.855 17.272 226.999 17.388 226.039 17.388H219.967V0.192001H225.451ZM242.576 10.536V17.388H240.248V10.536L233.948 0.192001H235.988C236.196 0.192001 236.36 0.244 236.48 0.348C236.6 0.444 236.704 0.572002 236.792 0.732002L240.728 7.416C240.872 7.696 241.004 7.96 241.124 8.208C241.244 8.448 241.348 8.692 241.436 8.94C241.524 8.692 241.624 8.448 241.736 8.208C241.848 7.96 241.972 7.696 242.108 7.416L246.032 0.732002C246.104 0.596002 246.204 0.472001 246.332 0.360001C246.46 0.248001 246.624 0.192001 246.824 0.192001H248.876L242.576 10.536Z",
        fill: "#656565"
      }));
    }
  },
  // 'mui-arrowDownward': {
  //   size: 15,
  //   viewBox: '0 0 15 15',
  //   element: (props: SvgIconProps): JSX.Element => (
  //     <g fill="currentcolor" fillRule="nonzero" filter={props.filter}>
  //       <path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z" />
  //     </g>
  //   )
  // },
  'mui-arrowDropDown': {
    size: 14,
    viewBox: '0 0 14 14',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        fillRule: "nonzero",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M7 10l5 5 5-5z",
        transform: "translate(-4, -4)"
      }));
    }
  },
  // 'mui-cancel': {
  //   size: 15,
  //   viewBox: '0 0 15 15',
  //   element: (props: SvgIconProps): JSX.Element => (
  //     <g fill="currentcolor" fillRule="nonzero" filter={props.filter}>
  //       <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
  //     </g>
  //   )
  // },
  // 'mui-checkBox': {
  //   size: 15,
  //   viewBox: '0 0 15 15',
  //   element: (props: SvgIconProps): JSX.Element => (
  //     <g fill="currentcolor" fillRule="nonzero" filter={props.filter}>
  //       <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
  //     </g>
  //   )
  // },
  // 'mui-checkBoxOutlineBlank': {
  //   size: 15,
  //   viewBox: '0 0 15 15',
  //   element: (props: SvgIconProps): JSX.Element => (
  //     <g fill="currentcolor" fillRule="nonzero" filter={props.filter}>
  //       <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
  //     </g>
  //   )
  // },
  // 'mui-checkCircle': {
  //   size: 15,
  //   viewBox: '0 0 15 15',
  //   element: (props: SvgIconProps): JSX.Element => (
  //     <g fill="currentcolor" fillRule="nonzero" filter={props.filter}>
  //       <path d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z" />
  //     </g>
  //   )
  // },
  // 'mui-close': {
  //   size: 15,
  //   viewBox: '0 0 15 15',
  //   element: (props: SvgIconProps): JSX.Element => (
  //     <g fill="currentcolor" fillRule="nonzero" filter={props.filter}>
  //       <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
  //     </g>
  //   )
  // },
  // 'mui-indeterminateCheckBox': {
  //   size: 15,
  //   viewBox: '0 0 15 15',
  //   element: (props: SvgIconProps): JSX.Element => (
  //     <g fill="currentcolor" fillRule="nonzero" filter={props.filter}>
  //       <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z" />
  //     </g>
  //   )
  // },
  'mui-keyboardArrowLeft': {
    size: 14,
    viewBox: '0 0 14 14',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        fillRule: "nonzero",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z",
        transform: "translate(-5, -4)"
      }));
    }
  },
  'mui-keyboardArrowRight': {
    size: 14,
    viewBox: '0 0 14 14',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        fillRule: "nonzero",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z",
        transform: "translate(-4, -4)"
      }));
    }
  },
  'mui-moreHoriz': {
    size: 14,
    viewBox: '0 0 14 14',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        fillRule: "nonzero",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
        transform: "translate(-3.5, -3.5) scale(.92, .92)"
      }));
    }
  },
  'mui-person': {
    size: 15,
    viewBox: '0.05 0 15 15',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        fillRule: "nonzero",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
        transform: "translate(-3.5, -3.5) scale(.92, .92)"
      }));
    }
  },
  'mui-radioButtonChecked': {
    size: 15,
    viewBox: '0 0 15 15',
    element: function element(props) {
      var secondaryColor = props.secondaryColor;
      return /*#__PURE__*/React.createElement("g", {
        fillRule: "nonzero",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(-1.5, -1.5) scale(.75, .75)"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z",
        fill: "currentcolor"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z",
        fill: secondaryColor ? secondaryColor : 'currentcolor'
      })));
    }
  },
  'mui-radioButtonUnchecked': {
    size: 15,
    viewBox: '0 0 15 15',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        fillRule: "nonzero",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(-1.5, -1.5) scale(.75, .75)"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
      })));
    }
  },
  'mui-warning': {
    size: 15,
    viewBox: '0 0 15 15',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        fillRule: "nonzero",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(-0.5, -0.25) scale(.68, .68)"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
      })));
    }
  },
  cameraShutter: {
    size: {
      width: 24,
      height: 24
    },
    viewBox: '0 0 327.512 327.512',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        fillRule: "nonzero",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M163.758,0C73.463,0,0,73.461,0,163.756s73.463,163.755,163.758,163.755c90.294,0,163.754-73.461,163.754-163.755 S254.052,0,163.758,0z M183.346,212.618c-0.016,0-0.039,0.007-0.055,0.007h-47.75l-28.207-48.869l28.207-48.87h8.621h47.811 l28.209,48.87l-28.203,48.862H183.346z M27.793,201.501c-3.348-12.021-5.172-24.668-5.172-37.746 c0-17.175,3.093-33.633,8.732-48.87h78.068l-7.27,12.592L27.793,201.501z M225.234,200.253l74.494-74.234 c3.341,12.023,5.162,24.664,5.162,37.736c0,17.175-3.09,33.632-8.729,48.869l-78.066-0.007L225.234,200.253z M291.016,102.758 l-50.735,50.559l-7.036-12.188V40.983C258.23,55.181,278.504,76.752,291.016,102.758z M210.623,30.65v71.297l-2.326-4.026 c-0.076-0.138-0.197-0.237-0.287-0.37c-0.354-0.563-0.756-1.088-1.221-1.591c-0.188-0.204-0.365-0.409-0.57-0.602 c-0.121-0.11-0.207-0.243-0.336-0.354l-78.487-67.613c11.608-3.098,23.793-4.771,36.362-4.771 C180.182,22.621,195.949,25.469,210.623,30.65z M103.113,36.338l64.922,55.928h-23.873h-15.146H42.139 C56.408,68.088,77.654,48.5,103.113,36.338z M36.496,224.751l50.756-50.524l7.013,12.145v100.151 C69.281,272.324,49.008,250.751,36.496,224.751z M116.886,296.855v-71.303l2.331,4.037c0.076,0.14,0.199,0.237,0.288,0.371 c0.353,0.562,0.763,1.088,1.22,1.59c0.189,0.205,0.369,0.408,0.57,0.603c0.122,0.11,0.209,0.244,0.336,0.354l78.488,67.613 c-11.611,3.1-23.793,4.771-36.361,4.771C147.326,304.89,131.562,302.041,116.886,296.855z M224.402,291.171l-64.929-55.926h39.023 c0.014,0,0.022-0.007,0.039-0.007l86.839,0.007C271.109,259.423,249.859,279.011,224.402,291.171z"
      }));
    }
  },
  dslrCamera: {
    size: {
      width: 24,
      height: 24
    },
    viewBox: '0 0 307.308 307.308',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        fillRule: "nonzero",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M284.909,66.146h-81.345l-16.426-27.595c-1.607-2.698-4.514-4.351-7.654-4.351h-51.662c-3.14,0-6.048,1.653-7.654,4.351 l-16.426,27.595H77.049v-6.082c0-4.919-3.988-8.907-8.907-8.907H35.185c-4.92,0-8.907,3.988-8.907,8.907v6.082h-3.88 C10.027,66.146,0,76.174,0,88.543v162.166c0,12.37,10.027,22.398,22.397,22.398h262.512c12.37,0,22.398-10.028,22.398-22.398 V88.543C307.308,76.174,297.279,66.146,284.909,66.146z M153.653,233.379c-35.21,0-63.753-28.543-63.753-63.754 c0-35.209,28.543-63.753,63.753-63.753c35.21,0,63.753,28.544,63.753,63.753C217.406,204.836,188.863,233.379,153.653,233.379z M270.935,112.322h-27.91c-4.919,0-8.907-3.988-8.907-8.908c0-4.92,3.988-8.908,8.907-8.908h27.91c4.921,0,8.908,3.988,8.908,8.908 C279.843,108.334,275.855,112.322,270.935,112.322z"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "153.653",
        cy: "169.625",
        r: "44.538"
      }));
    }
  },
  print: {
    size: 20,
    viewBox: '0 0 22 23',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        fillRule: "nonzero",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M20.5065 8.75634H18.5698V6.18782V5.25381L14.8103 1.16751L13.785 0H3.41776V8.8731H1.59495C0.683552 8.8731 0 9.5736 0 10.5076V17.8629C0 18.797 0.683552 19.4975 1.59495 19.4975H3.41776V23H18.4559V19.4975H20.3926C21.304 19.4975 21.9876 18.797 21.9876 17.8629V10.5076C22.1015 9.45685 21.418 8.75634 20.5065 8.75634ZM13.4432 1.51777H13.5571L16.8609 5.13706H13.4432V1.51777ZM4.89879 1.40102H12.19V6.18782H17.0888V8.75634H4.89879V1.40102ZM17.2027 17.2792V19.264V21.3655H4.89879V19.264V17.2792V15.4112H17.2027V17.2792ZM20.3926 17.2792H18.4559V14.0102H3.41776V17.2792H1.70888V12.0254H20.3926V17.2792Z"
      }));
    }
  },
  papers: {
    size: {
      width: 210,
      height: 180
    },
    viewBox: '0 0 210 180',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        stroke: "#C2C2C2",
        fill: "none",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        fill: "#FFF",
        d: "M71.5 21.3l37.5 6.8 45.9 108.8L55 179.3.7 51.3l70.8-30.1z"
      }), /*#__PURE__*/React.createElement("path", {
        fill: "#FFF",
        d: "M34.8 81.7L62.5 70l11.7 27.7-27.7 11.7z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M63.5 66.4l31.8-13.5m-27.8 23l31.9-13.5m-27.8 23l31.8-13.5m-27.8 23l31.9-13.5m-27.3 24.4l31.9-13.5m-27.9 23l31.9-13.5m-27.8 23l31.9-13.5m-27.8 23l31.9-13.5"
      }), /*#__PURE__*/React.createElement("path", {
        fill: "#FFF",
        d: "M125.5 13.5l31.8 20.9-.3 118.1H48.5v-139h77z"
      }), /*#__PURE__*/React.createElement("path", {
        fill: "#FFF",
        d: "M62.5 52.4h30.1v30.1H62.5zm0 42.8h30.1v30.1H62.5z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M100.4 51.9H135m-34.6 10.3H135m-34.6 10.3H135m-34.6 10.3H135m-34.6 11.9H135M100.4 105H135m-34.6 10.3H135m-34.6 10.3H135"
      }), /*#__PURE__*/React.createElement("path", {
        fill: "#FFF",
        d: "M184.9 27.4L207.7 58 167 168.8 65 131.7 112.6 1.1l72.3 26.3z"
      }), /*#__PURE__*/React.createElement("path", {
        fill: "#FFF",
        d: "M112.4 42.4l28.2 10.3-10.3 28.2-28.2-10.3zM97.8 82.7L126 93l-10.3 28.2-28.2-10.3z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M148.2 54.9l32.5 11.8m-36.1-2.1l32.5 11.8M141 74.3l32.5 11.8M137.4 84l32.5 11.8m-36.3-.7l32.5 11.8m-36.1-2.1l32.5 11.8m-36.1-2.1l32.5 11.8m-36.1-2.1l32.5 11.8"
      }));
    }
  },
  headShot: {
    size: {
      width: 50,
      height: 50
    },
    viewBox: '0 0 50 50',
    element: function element(props) {
      var _props$fill = props.fill,
        fill = _props$fill === void 0 ? '#C2C2C2' : _props$fill,
        _props$secondaryColor2 = props.secondaryColor,
        secondaryColor = _props$secondaryColor2 === void 0 ? '#EFEFEF' : _props$secondaryColor2;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
        id: "path-1",
        x: "0",
        y: "0",
        width: "50",
        height: "50"
      })), /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        transform: "translate(0, 2)"
      }, /*#__PURE__*/React.createElement("g", {
        id: "Mask"
      }, /*#__PURE__*/React.createElement("mask", {
        id: "mask-2",
        fill: "white"
      }, /*#__PURE__*/React.createElement("use", {
        xlinkHref: "#path-1"
      })), /*#__PURE__*/React.createElement("use", {
        fill: secondaryColor,
        xlinkHref: "#path-1"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M25.898338,6.00000767 C25.7475793,5.99982223 25.5798991,6.0030003 25.4130545,6.00929888 C25.2460574,6.0030003 25.0782191,5.99982223 24.7691021,6.00000767 C21.6969536,6.27816846 18.9234712,7.60416411 18.9234712,8.11241821 C17.9274004,9.00049288 16.9302907,9.24084298 16.4324163,10.9332307 C13.9412541,12.0618409 14.9379798,18.8321657 14.9379798,18.8321657 C14.9379798,18.8321657 15.4361817,22.2173505 14.9379798,22.2173505 C14.4394504,22.2173505 14.2496992,22.4086675 14.0956432,23.566993 C14.0956432,24.4214709 14.5985541,26.1304077 14.5985541,26.1304077 C14.5985541,26.1304077 15.1016343,28.12961 15.1016343,28.6938607 C15.1016343,29.5483259 15.3583322,29.8331497 15.8560938,29.8331497 C16.1075746,29.8331497 16.8620849,29.5483259 16.9303415,29.5517789 C16.6105984,30.4028038 18.4247272,34.6294857 17.9265817,35.7579105 C17.4286564,36.8863352 15.9338868,38.5788573 13.9415815,38.5788573 C11.9489996,38.5788573 0.989420035,43.5370573 -0.00714477831,44.7849953 C-1.00327088,46.0325131 -2,52 -2,52 L53,52 C52.8232294,51.985602 51.8276555,46.0309951 50.8327874,44.7849953 C49.8362818,43.5370573 38.8766464,38.5788573 36.8840644,38.5788573 C34.8917535,38.5788573 33.3969896,36.8863352 32.8990643,35.7579105 C32.4008623,34.6294857 34.2150419,30.402791 33.8952988,29.5517661 C33.9635555,29.5483259 34.7180149,29.8331433 34.9695522,29.8331433 C35.4673138,29.8331433 35.724006,29.5483259 35.724006,28.6938543 C35.724006,28.12961 36.2270354,26.1304077 36.2270354,26.1304077 C36.2270354,26.1304077 36.7300028,24.4214582 36.7300028,23.566993 C36.5759411,22.4086675 36.3861391,22.2173505 35.8876605,22.2173505 C35.3894642,22.2173505 35.8876605,18.8321209 35.8876605,18.8321209 C35.8876605,18.8321209 36.8843919,12.0618409 34.3931733,10.9332307 C33.8953552,9.24084298 32.8982399,9.00049288 31.9021692,8.11237345 C31.9021692,7.60416411 29.1286923,6.27816846 25.898338,6.16690414 L25.898338,6.00000767 Z",
        fill: fill,
        mask: "url(#mask-2)"
      }))));
    }
  },
  mail: {
    size: 24,
    viewBox: '0 0 24 24',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        strokeWidth: props.strokeWidth || 1,
        fill: "currentcolor",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M20,4 C21.1,4 22,4.9 22,6 L22,6 L22,18 C22,19.1 21.1,20 20,20 L20,20 L4,20 C2.9,20 2,19.1 2,18 L2,18 L2.01,6 C2.01,4.9 2.9,4 4,4 L4,4 Z M20,8 L12,13 L4,8 L4,18 L20,18 L20,8 Z M20,6 L4,6 L12,11 L20,6 Z",
        id: "fill-color"
      }));
    }
  },
  alert: {
    size: 22,
    viewBox: '0 0 19 22',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        strokeWidth: props.strokeWidth || 1,
        fill: "none",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
        points: "0.0200709299 17.3948059 0.0200709299 0.0133806199 18.7328679 0.0133806199 18.7328679 8.70409325 18.7328679 17.3948059"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M17.3948059,14.7186819 C16.7819735,14.7186819 16.0567439,13.9934523 16.0567439,13.3806199 L16.0567439,6.69030995 C16.0567439,3.00160756 13.0551363,0 9.36643393,0 C5.67773154,0 2.67612398,3.00160756 2.67612398,6.69030995 L2.67612398,13.3806199 C2.67612398,13.9804062 1.93784828,14.7186819 1.33806199,14.7186819 C0.598448225,14.7186819 0,15.3171301 0,16.0567439 C0,16.7963577 0.598448225,17.3948059 1.33806199,17.3948059 L17.3948059,17.3948059 C18.1344196,17.3948059 18.7328679,16.7963577 18.7328679,16.0567439 C18.7328679,15.3171301 18.1344196,14.7186819 17.3948059,14.7186819",
        fill: "currentcolor"
      })), /*#__PURE__*/React.createElement("path", {
        d: "M9.36643393,21.4089919 C10.8443234,21.4089919 12.0425579,20.2107573 12.0425579,18.7328679 L6.69030995,18.7328679 C6.69030995,20.2107573 7.88854447,21.4089919 9.36643393,21.4089919",
        fill: "currentcolor"
      }));
    }
  },
  'g-icon-add': {
    size: 24,
    viewBox: '0 0 24 24',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M0 0h24v24H0V0z",
        fill: "none"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
      }));
    }
  },
  'g-icon-remove': {
    size: 24,
    viewBox: '0 0 24 24',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M0 0h24v24H0V0z",
        fill: "none"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M19 13H5v-2h14v2z"
      }));
    }
  },
  'question-with-boarder': {
    size: 24,
    viewBox: '0 0 24 24',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: props.strokeWidth || 1,
        fillRule: "evenodd",
        fill: "currentcolor",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M11,18 L13,18 L13,16 L11,16 L11,18 Z M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M12,20 C7.59,20 4,16.41 4,12 C4,7.59 7.59,4 12,4 C16.41,4 20,7.59 20,12 C20,16.41 16.41,20 12,20 Z M12,6 C9.79,6 8,7.79 8,10 L10,10 C10,8.9 10.9,8 12,8 C13.1,8 14,8.9 14,10 C14,12 11,11.75 11,15 L13,15 C13,12.75 16,12.5 16,10 C16,7.79 14.21,6 12,6 Z"
      }));
    }
  },
  download: {
    size: 20,
    viewBox: '0 0 20 20',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: props.strokeWidth || 1,
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentcolor",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
      }));
    }
  },
  lock: {
    size: 16,
    viewBox: '0 0 16 21',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: props.strokeWidth || 1,
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentcolor",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M8 16c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V5c0-2.76-2.24-5-5-5S3 2.24 3 5v2H2C.9 7 0 7.9 0 9v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM4.9 5c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H4.9V5zM14 19H2V9h12v10z"
      }));
    }
  },
  unlock: {
    size: 16,
    viewBox: '0 0 21 21',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: props.strokeWidth || 1,
        fillRule: "nonzero",
        clipRule: "evenodd",
        fill: "currentcolor",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M8 12a2 2 0 012 2c0 1.11-.89 2-2 2-1.11 0-2-.89-2-2a2 2 0 012-2m8-12c-2.76 0-5 2.24-5 5v2H2C.9 7 0 7.9 0 9v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2h-1V5c0-1.66 1.34-3 3-3s3 1.34 3 3v2h2V5c0-2.76-2.24-5-5-5m-2 9v10H2V9h12z"
      }));
    }
  },
  document: {
    size: 25,
    viewBox: '0 0 20 25',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M-1.758.09h24v24h-24z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M5.442 16.89h9.6v2.4h-9.6v-2.4zm0-4.8h9.6v2.4h-9.6v-2.4zm7.2-12h-9.6c-1.32 0-2.4 1.08-2.4 2.4v19.2c0 1.32 1.068 2.4 2.388 2.4h14.412c1.32 0 2.4-1.08 2.4-2.4V7.29l-7.2-7.2zm4.8 21.6h-14.4V2.49h8.4v6h6v13.2z",
        fill: "currentcolor",
        fillRule: "nonzero"
      }));
    }
  },
  calendar: {
    size: 24,
    viewBox: '0 0 24 24',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentColor",
        stroke: "currentColor",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"
      }));
    }
  },
  thickCircle: {
    size: 26,
    viewBox: '-1 -1 24 24',
    element: function element(props) {
      var _props$secondaryColor3, _props$strokeWidth8;
      return /*#__PURE__*/React.createElement("g", {
        fill: typeof props.fill === 'number' ? 'none' : props.fill,
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("circle", {
        cx: 11,
        cy: 11,
        r: 10,
        fill: "none",
        stroke: (_props$secondaryColor3 = props.secondaryColor) !== null && _props$secondaryColor3 !== void 0 ? _props$secondaryColor3 : 'currentcolor',
        strokeWidth: (_props$strokeWidth8 = props.strokeWidth) !== null && _props$strokeWidth8 !== void 0 ? _props$strokeWidth8 : 4
      }));
    }
  },
  slashCircle: {
    size: 26,
    viewBox: '-1 -1 24 24',
    element: function element(props) {
      var _props$strokeWidth9, _props$strokeWidth10;
      return /*#__PURE__*/React.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("line", {
        x1: 17,
        y1: 2.5,
        x2: 5,
        y2: 19,
        stroke: "currentcolor",
        strokeWidth: (_props$strokeWidth9 = props.strokeWidth) !== null && _props$strokeWidth9 !== void 0 ? _props$strokeWidth9 : 4
      }), /*#__PURE__*/React.createElement("circle", {
        cx: 11,
        cy: 11,
        r: 10,
        fill: "none",
        stroke: "currentcolor",
        strokeWidth: (_props$strokeWidth10 = props.strokeWidth) !== null && _props$strokeWidth10 !== void 0 ? _props$strokeWidth10 : 4
      }));
    }
  },
  gallery: {
    size: 25,
    viewBox: '0 0 26 26',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd",
        filter: props.filter
      }, /*#__PURE__*/React.createElement("rect", {
        width: "11",
        height: "11"
      }), /*#__PURE__*/React.createElement("rect", {
        x: "14",
        width: "11",
        height: "11"
      }), /*#__PURE__*/React.createElement("rect", {
        y: "14",
        width: "11",
        height: "11"
      }), /*#__PURE__*/React.createElement("rect", {
        x: "14",
        y: "14",
        width: "11",
        height: "11"
      }));
    }
  },
  copy: {
    size: 25,
    viewBox: '0 0 34 32',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        filter: props.filter
      }, /*#__PURE__*/React.createElement("path", {
        fill: "currentcolor",
        d: "M6.735-.762l.113 7.384h-7.61v26.14h26.557v-7.384h7.625V-.762H6.735zM8.283.762h23.613v23.092h-5.985V6.622H8.375L8.283.762zM.762 8.146h23.509v23.092H.762V8.146z"
      }));
    }
  },
  costarMarker: {
    size: 33,
    viewBox: '0 0 20 33',
    element: function element(props) {
      var _props$secondaryColor4, _props$strokeWidth11;
      return /*#__PURE__*/React.createElement("g", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
        cx: "50%",
        cy: "49.6469329%",
        fx: "50%",
        fy: "49.6469329%",
        r: "165.201786%",
        gradientTransform: "translate(0.500000,0.496469),scale(0.304348,1.000000),scale(1.000000,0.274581),translate(-0.500000,-0.496469)",
        id: "radialGradient-1"
      }, /*#__PURE__*/React.createElement("stop", {
        stopColor: "#001122",
        stopOpacity: "0.537760417",
        offset: "0%"
      }), /*#__PURE__*/React.createElement("stop", {
        stopColor: "#001122",
        stopOpacity: "0",
        offset: "100%"
      }))), /*#__PURE__*/React.createElement("g", {
        id: "CoStar-UI-Kit",
        stroke: (_props$secondaryColor4 = props.secondaryColor) !== null && _props$secondaryColor4 !== void 0 ? _props$secondaryColor4 : 'currentcolor',
        strokeWidth: (_props$strokeWidth11 = props.strokeWidth) !== null && _props$strokeWidth11 !== void 0 ? _props$strokeWidth11 : 0,
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(-123.000000, -6672.000000)",
        fillRule: "nonzero",
        id: "PINS"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(37.000000, 3053.000000)"
      }, /*#__PURE__*/React.createElement("g", {
        id: "active",
        transform: "translate(86.000000, 3619.000000)"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M0.8,11 C0.6,10.6 0.7,10 1,9.6 L9.4,1.2 C9.7,0.9 10.2,0.9 10.5,1.2 L19,9.6 C19.3,9.9 19.4,10.5 19.2,11 L10.5,29.6 C10.3,30 10,30 9.8,29.6 L0.8,11 Z",
        id: "Shape",
        fill: "currentcolor",
        filter: props.filter
      }))))));
    }
  },
  exclamation: {
    size: 24,
    viewBox: '0 0 24 24',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("path", {
        fill: "currentcolor",
        filter: props.filter,
        d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
      });
    }
  },
  share: {
    size: 33,
    viewBox: '0 0 25 25',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        overflow: "hidden",
        filter: props.filter,
        height: "25",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("g", {
        id: "Share-Group"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M16,11 C17.66,11 18.99,9.66 18.99,8 C18.99,6.34 17.66,5 16,5 C14.34,5 13,6.34 13,8 C13,9.66 14.34,11 16,11 Z M8,11 C9.66,11 10.99,9.66 10.99,8 C10.99,6.34 9.66,5 8,5 C6.34,5 5,6.34 5,8 C5,9.66 6.34,11 8,11 Z M8,13 C5.67,13 1,14.17 1,16.5 L1,19 L15,19 L15,16.5 C15,14.17 10.33,13 8,13 Z M16,13 C15.71,13 15.38,13.02 15.03,13.05 C16.19,13.89 17,15.02 17,16.5 L17,19 L23,19 L23,16.5 C23,14.17 18.33,13 16,13 Z",
        id: "Shape",
        fill: "#001122",
        fillRule: "nonzero"
      })));
    }
  },
  updatePencil: {
    size: 24,
    viewBox: '0 0 24 24',
    element: function element(props) {
      return /*#__PURE__*/React.createElement("g", {
        fill: "currentcolor",
        overflow: "hidden",
        filter: props.filter,
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M3,17.2525 L3,21.0025 L6.75,21.0025 L17.81,9.9425 L14.06,6.1925 L3,17.2525 Z M20.71,7.0425 C21.1,6.6525 21.1,6.0225 20.71,5.6325 L18.37,3.2925 C17.98,2.9025 17.35,2.9025 16.96,3.2925 L15.13,5.1225 L18.88,8.8725 L20.71,7.0425 Z"
      }));
    }
  },
  locationHQ: {
    size: 28,
    viewBox: '0 0 28 28',
    element: function element(props) {
      var _props$secondaryColor5 = props.secondaryColor,
        secondaryColor = _props$secondaryColor5 === void 0 ? '#FFFFFF' : _props$secondaryColor5,
        _props$strokeWidth12 = props.strokeWidth,
        strokeWidth = _props$strokeWidth12 === void 0 ? '1' : _props$strokeWidth12;
      return /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: strokeWidth,
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("circle", {
        stroke: "currentcolor",
        fill: secondaryColor,
        cx: "13",
        cy: "13",
        r: "13"
      }), /*#__PURE__*/React.createElement("g", {
        transform: "translate(7.283951, 5.000000)",
        fill: "currentcolor"
      }, /*#__PURE__*/React.createElement("polygon", {
        id: "fill-color",
        points: "8.04609053 1.81263617 7.7037037 0 0 0 0 15.4074074 1.71193416 15.4074074 1.71193416 9.06318083 6.50534979 9.06318083 6.84773663 10.875817 12.8395062 10.875817 12.8395062 1.81263617"
      })));
    }
  }
};

export default svgIcons;
//# sourceMappingURL=svg-icons.esm.js.map
